'use strict';

function buildChartMenu() {
	var _this = this,
		menuConfig = _this.config.menu;

	_this.menu = {
		wrapper: _this.cnt.wrapper,
		teLogo: _this.cnt.teLogo,
		bottom_wrapper: _this.cnt.footer,
		cnt: div({}, {
			"class": isDarkMode == true ? 'iChart-headerMenu2 darkTopWrapper' : 'iChart-headerMenu2'
		}),
		config: menuConfig,
		options: {},
		context: _this.config.cdata.bs,
		theme: _this.config.theme,
		//menu update callbacks
		events: {
			intervalSpanChange: function intervalSpanChange(interval, span) {
				_this.update('span', span, false);
				_this.update('interval', interval);
			},
			datePickerChange: function datePickerChange(start, end) {
				_this.update('datePicker', {d1: start,d2: end});
			},
			spanChange: function spanChange(span) {
				_this.update('span', span);
			},
			typeChange: function typeChange(type) {
				_this.update('type', type);
			},
			search: function search(symbol, compare) {
				if (compare) {
					if (symbol && symbol.slice(-3) != ':te') {
						_this.config.cdata.span="1y";
					} else {
						_this.config.cdata.span="5y";
					}
					_this.update('bs', symbol);
				} else {
					_this.update('bs', symbol, true, true);
				}
			},
			replaceSymbol: function replaceSymbol(originalSymbol, newSymbol) {
				_this.config.cdata.span = "1y";
				_this.menu.context = newSymbol;
				_this.changeSerieByBs(originalSymbol, newSymbol);
			},
			fullscreenClick: function fullscreenClick(isFullScreen) {
				if (isFullScreen) {
					return cancelFullScreen();
				}

				$(".techart").css('top', screen.height - 165 +'px');
				requestFullScreen.call(_this, _this.cnt.wrapper[0]);
			},
			fullscreenChange: function fullscreenChange(isFullScreen) {
				if (!isFullScreen) {
					return cancelFullScreen();
				}
				_this.reflow();
			},
			zoom: function zoom(side) {
				_this.tiny = null;
				_this.hotkey(side);
			},
			moveAxis: function moveAxis(side, delta) {
				_this.moveAxis(side, delta);
			}
		},
		calcDropDownPos: function calcDropDownPos(btn, dp) {
			var pos,
			    btnOffset = btn.offset(),
			    wrapperOffset = this.wrapper.offset();

			pos = {
				top: btnOffset.top - wrapperOffset.top,
				left: btnOffset.left - wrapperOffset.left
			};

			switch (this.config.style) {
				case 'top':
					pos.top += btn.outerHeight(true);
					pos.left -= dp.outerWidth(true) - btn.outerWidth();
					break;

				case 'topright':
					pos.top += btn.outerHeight(true);
					pos.left -= dp.outerWidth(true) - btn.outerWidth();
					break;

				case 'topleft':
					break;
			};

			return pos;
		},
	};

	var fsChangeFunc = function fsChangeFunc(e) {
		if (isFS == true ) {
			_this.chart.update({
				exporting: { width: 750,
					height: 520,
					sourceWidth: 750, /*EXPORTING SIZE*/
					sourceHeight: 520, }
			});

			$('#iChart-bottom-right-horizontal').removeClass('Fs-bottom-options-horizontal')
			$('#iChart-bottom-left-horizontal').removeClass('Fs-bottom-options-horizontal')
			$('.iChart-wrapper-footer').css('font-size',regularFontSize)
			isFS = false;
			$("#fullscreen").text("View in full screen")
			document.querySelector(".fullscreenBtn").title = "View in full screen"
			document.querySelector(".fullscreenBtn").removeChild(document.querySelector(".fullscreenBtn").firstElementChild)
			document.querySelector(".fullscreenBtn").innerHTML = !isMobile? SVG_ICONS['fullscreen'] : SVG_ICONS['fullscreen_mobile']
		}
		else if (isFS == false) {
			_this.chart.update({
				exporting: { width: 1918,
					height: 950,
					sourceWidth: 1918, /*EXPORTING SIZE*/
					sourceHeight: 950, }
			});
			$('#iChart-bottom-right-horizontal').addClass('Fs-bottom-options-horizontal')
			$('#iChart-bottom-left-horizontal').addClass('Fs-bottom-options-horizontal')
			$('.iChart-wrapper-footer').css('font-size',regularFontSize)
			isFS = true;
		}
	};
	document.addEventListener('fullscreenchange', fsChangeFunc, {passive: true});
	document.addEventListener("webkitfullscreenchange", fsChangeFunc, {passive: true});
	document.addEventListener("mozfullscreenchange", fsChangeFunc, {passive: true});
	document.addEventListener("MSFullscreenChange", fsChangeFunc, {passive: true});


	_this.cnt.header.append(_this.menu.cnt);
	menuButtons.splice(0, 0, {
    text: "View in full screen",
    onclick: function () {
      if (isFS == false) {
        var _this_a = $(".iChart-wrapper")[0];
        requestFullScreen.call(this, _this_a);
      } else if (isFS == true) {
        cancelFullScreen.call();
      }
      if (all_serires.length == 2) {
        $(".ohlc_span ohlc_span_0").show();
      }
    },
  });
	/* TWITTER
	var chartImage = 'https://d3fy651gv2fhd3.cloudfront.net/charts/share.png?s=indu:ind&w=500'
	var svgtest = `<svg width='64px' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" 
	viewBox="0 0 122.88 38.48" style="enable-background:new 0 0 122.88 38.48" 
	xml:space="preserve"><style type="text/css"><![CDATA[.st0{fill:#1A91DA;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1DA1F2;}.st2{fill:#FFFFFF;}]]></style><g>
	<path class="st1" d="M118.69,0H4.19C1.89,0,0,1.89,0,4.19v30.11c0,2.3,1.89,4.19,4.19,4.19h114.5c2.3,0,4.19-1.89,4.19-4.19V4.19 C122.88,1.89,120.99,0,118.69,0L118.69,0L118.69,0z"/>
	<path class="st2" d="M51.99,21.34l3.13-0.23c0.07,0.59,0.21,1.04,0.42,1.34c0.34,0.5,0.82,0.75,1.46,0.75 c0.47,0,0.83-0.13,1.09-0.38c0.26-0.26,0.38-0.55,0.38-0.89c0-0.32-0.12-0.61-0.36-0.86c-0.24-0.25-0.8-0.49-1.68-0.72 c-1.45-0.37-2.47-0.88-3.09-1.5c-0.62-0.62-0.93-1.42-0.93-2.39c0-0.63,0.16-1.23,0.48-1.8c0.32-0.57,0.79-1.01,1.43-1.34 c0.64-0.32,1.51-0.48,2.62-0.48c1.36,0,2.4,0.29,3.12,0.89c0.72,0.59,1.14,1.53,1.28,2.81l-3.1,0.21 c-0.08-0.56-0.26-0.97-0.52-1.23c-0.27-0.26-0.63-0.38-1.1-0.38c-0.38,0-0.67,0.1-0.87,0.28s-0.29,0.42-0.29,0.69 c0,0.2,0.08,0.37,0.24,0.53c0.15,0.16,0.52,0.31,1.1,0.46c1.44,0.36,2.47,0.73,3.09,1.1c0.62,0.37,1.08,0.82,1.36,1.37 c0.28,0.54,0.42,1.16,0.42,1.83c0,0.79-0.19,1.53-0.57,2.2c-0.38,0.67-0.91,1.18-1.59,1.53c-0.68,0.35-1.53,0.52-2.57,0.52 c-1.81,0-3.07-0.41-3.77-1.22C52.48,23.62,52.08,22.59,51.99,21.34L51.99,21.34z M31.01,12.91c-0.75,0.34-1.56,0.56-2.4,0.66 c0.86-0.52,1.53-1.34,1.84-2.32c-0.81,0.48-1.71,0.83-2.66,
	1.02c-0.77-0.81-1.85-1.32-3.06-1.32c-2.31,0-4.19,1.87-4.19,4.19 c0,0.33,0.04,0.65,0.11,0.95c-3.48-0.18-6.57-1.84-8.63-4.38c-0.37,0.64-0.57,1.37-0.57,2.11l0,0c0,1.45,0.74,2.74,1.86,3.48 c-0.69-0.02-1.33-0.21-1.9-0.52v0.05c0,2.03,1.44,3.72,3.36,4.11c-0.35,0.1-0.72,0.15-1.1,0.15c-0.27,0-0.53-0.03-0.79-0.07 c0.54,1.66,2.08,2.87,3.91,2.91c-1.44,1.13-3.24,1.79-5.2,1.79c-0.34,0-0.67-0.02-1-0.06c1.86,1.19,4.06,1.88,6.42,1.88 c7.7,0,11.92-6.38,11.92-11.92c0-0.18,0-0.36-0.01-0.54C29.74,14.49,30.45,13.75,31.01,12.91L31.01,12.91L31.01,12.91L31.01,12.91 L31.01,12.91z M63.13,13.05h3.29v4.33h3.61v-4.33h3.31v12.39h-3.31v-5.02h-3.61v5.02h-3.29V13.05L63.13,13.05z M82.1,23.39h-3.74 l-0.54,2.04h-3.37l4.02-12.39h3.61l4,12.39h-3.45L82.1,23.39L82.1,23.39z M81.41,20.71l-1.17-4.45l-1.17,4.45H81.41L81.41,20.71z M87.18,25.44V13.05h5.5c1.02,0,1.8,0.1,2.33,0.31c0.54,0.2,0.98,0.58,1.3,1.13c0.33,0.55,0.5,1.22,0.5,2.01 c0,0.69-0.13,1.28-0.38,1.78c-0.25,0.5-0.6,0.91-1.04,1.22c-0.28,0.2-0.67,0.36-1.16,0.49c0.39,0.15,0.68,0.3,0.86,0.46 c0.12,0.1,0.3,0.32,0.53,0.65c0.23,0.33,0.38,0.59,0.46,0.77l1.6,3.58h-3.73l-1.76-3.78c-0.23-0.49-0.42-0.81-0.6-0.95 c-0.24-0.19-0.51-0.29-0.81-0.29h-0.29v5.02H87.18L87.18,25.44z M90.49,18.08h1.39c0.15,0,0.44-0.06,0.88-0.17 c0.22-0.05,0.4-0.18,0.53-0.39c0.14-0.21,0.21-0.45,0.21-0.72c0-0.4-0.11-0.71-0.33-0.92c-0.22-0.21-0.63-0.32-1.23-0.32h-1.45 V18.08L90.49,18.08z M98.74,13.05h8.83v2.65h-5.52v1.97h5.11v2.53h-5.11v2.44h5.68v2.8h-8.99V13.05L98.74,13.05z"/><polygon class="st0" points="40.66,0 40.66,38.48 38.27,38.48 38.27,0 40.66,0"/></g></svg>`

	menuButtons.push({
    text: `<a href="https://twitter.com/intent/tweet?text=dddd&url=https%3A%2F%2Fd3fy651gv2fhd3.cloudfront.net%2Fcharts%2Fshare.png%3Fs%3Dindu%3Aind">
		${svgtest}
		</a>`,
	});*/
	$('.iChart-headerMenu2').append('<div class="topnav-flex-container"></div>');
	buildChartMenu_.apply(_this);
};

function updateChartMenu() {
	
	var _this = this,
	    menuOptions = _this.menu.options;

	for (var key in menuOptions) {
		if (key == 'search') {
			var series = _this.series;

			if (Object.keys(series).length == 1) {
				menuOptions[key].update(series[Object.keys(series)[0]].config.shortname);
			} else {
				menuOptions[key].update('Search...');
			}
		} else if (key == 'interval') {

			var hideInterval = _this.series && _this.menu.config.headerLabels && Object.keys(_this.series).length == 1;

			menuOptions[key].update(_this.config.cdata, _this.chart, _this.isYield, hideInterval);
		} else {

			menuOptions[key].update(_this.config.cdata, _this.chart, _this.isYield);
		}
	}
	update_ChartOutSettings.apply(_this);
};

function buildChartMenu_() {
	var _this = this.menu,
		menuConfig = _this.config,
		__ = this;
	if (menuConfig.showLog) {
		log = true;
	}

	if (menuConfig.headerLabels) {
		buildChartMenu_headerLabels.apply(__, [menuConfig.headerSearch]);
	}

	if (menuConfig.bodyLabels) {
		buildChartMenu_bodyLabels.apply(__);
	}

	if (menuConfig.bodyLabelsMoreSeries) {
		bodyLabelsMoreSeries = true;
	}

	if (menuConfig.controlBar) {
		buildChartMenu_controlBar.apply(_this);
	}

	if (menuConfig.fullscreen) {
		buildChartMenu_fullscreen.apply(_this);
	}

	if (menuConfig.calendar) {
		buildChartMenu_calendar.apply(_this);
	}

	if (menuConfig.span) {
		if (menuConfig.span == 'bottom') {
			buildChartMenu_span_bottom.apply(_this);
		}
	}
};

function buildChartMenu_headerLabels() {
	var addSearch = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

	var _this = this.menu,
	    sLen = _this.context.split(',').length,
	    labels = {
		labels: {}
	},
	    addBtn;

	var labelsCnt = div({}, {
		'class': 'iChart-menu-cnt-labels header-buttons'
	});

	_this.cnt.append(labelsCnt);

	labels.cnt = labelsCnt;

	labels.update = function (cdata, chart, isYield) {

		var series = chart.series;

		for (var i = 0; i < series.length-1; i++) {
			var s = series[i],
			    id = s.options.id;

			if (s.options.isTail || s.options.type == 'trendline' || s.options.id == 'null:cur') {
				continue;
			}

			(function (newId) {
				var label = labels.labels[id];
				if (!label) {
					var ta = div({}, {
						'class': isDarkMode == true ? 'thin scrollbar-black dark-bordered-black iChart-dpMenu-typeahead darkTopWrapper' : 'thin scrollbar-black bordered-black iChart-dpMenu-typeahead'
					});
					_this.wrapper.append(ta);
					if(id = cdata.mainSymbol) {

						label = labels.labels[newId] = new HeaderLabel({
							chart: chart,
							menu: _this,
							chartWrapper: _this.wrapper,
							taCnt: ta,

							onTaFocus: function onTaFocus() {
								console.info(label, labels, 'thelabelEX', id, newId, label.cnt.get(0).offsetLeft);

								ta.css({
									top: 40,
									left: label.cnt.get(0).offsetLeft + 5
								});
							}
						});

						labels.cnt.append(label.cnt);
					}
					ta.css({
						top: 40,
						left: label.cnt.get(0).offsetLeft + 5
					});
				}

				if(cdata.searchSymbol) {
					label.setSerie(s, cdata, _this);
					var l = labels.labels[cdata.oldSymbol];
					if (l) l.remove();
					delete labels.labels[cdata.oldSymbol];
					label.show();
				}else{
					label.setSerie(s, cdata, _this);
					label.show();
				}
			})(id);
		} //end for

		if (series.length < 4) {
			if (!addBtn) {
				buildChartMenu_headerLabelsAdd.call(this, function (refBtn) {
					addBtn = refBtn;
				});
			} else addBtn.show();
		}
	};

	_this.options['labels'] = labels;

	//load OHLC
	if (addSearch) {
		if (sLen < 4) buildChartMenu_headerLabelsAdd.call(this, function (refBtn) {
			addBtn = refBtn;
		});
	}
};

//bodyLabels
function buildChartMenu_bodyLabels() {
	var _this = this.menu,
	    bodyLabels = {
			labels: {}
		};

	var labelsDivx = div({}, {
		'id': 'iChart-bodyLabels-cntx'
	});

	var labelsDiv = div({}, {
		'id': 'iChart-bodyLabels-cnt'
	});

	var labelsDiv2 = div({}, {
		'id': 'iChart-bodyLabels-cnt2'
	});

	var labelsDiv3 = div({}, {
		'id': 'iChart-bodyLabels-cnt3'
	});

	var labelsDiv4 = div({}, {
		'id': 'iChart-bodyLabels-cnt4'
	});

	var labelsDiv5 = div({}, {
		'id': 'iChart-bodyLabels-cnt5'
	});

	labelsDiv.hide();
	labelsDiv2.hide();
	labelsDiv3.hide();
	labelsDiv4.hide();
	labelsDiv5.hide();

	_this.wrapper.append(labelsDivx);
	_this.wrapper.append(labelsDiv);
	_this.wrapper.append(labelsDiv2);
	_this.wrapper.append(labelsDiv3);
	_this.wrapper.append(labelsDiv4);
	_this.wrapper.append(labelsDiv5);

	_this.options['bodyLabels'] = bodyLabels;

	bodyLabels.cnt = labelsDiv;

	bodyLabels.update = function (cdata, chart, isYield) {

		var series = chart.series

		if (all_serires.length == 1) {
			if(!isMobile){
				labelsDivx.css("top", 50)
			}else{
				labelsDivx.css("top", 50)
				labelsDivx.css("justify-content", "left")
			}
			labelsDivx.css("left", 7)
		}

		if (all_serires.length >= 2) {
			labelsDivx.css('font-size', regularFontSize,)
			labelsDivx.css("top", 39)
			if(!isMobile){
				if(secondaryAxisMargin == false){
				labelsDivx.css("left", 0)
				}else{
					labelsDivx.css("left", 65) //???? 60
				}
				labelsDivx.css("top", 50)
			}else{
				labelsDivx.css("left", 0)
				labelsDivx.css("top", 45)
				// labelsDivx.css("justify-content", "center")
			}
		}

		labelsDiv.empty();
		labelsDiv2.empty();
		labelsDiv3.empty();
		labelsDiv4.empty();
		labelsDiv5.empty();

		var series = chart.series;
		var s = series[0];

		if (!s || !s.options) {
			return;
		}

		labelsDiv.addClass(cdata.mainSymbol);
		var dataArr = s.options.data;

		function getChartTitleForLabel (serie) {
			try {
				//return serie.options.db_type == 'currency' ? serie.options.id.split(':')[0].toUpperCase() : serie.options.full_name || s.options.shortname;
			return serie.options.full_name || s.options.shortname || serie.options.id.split(':')[0].toUpperCase();	
			}
			catch(err) {}
		}

		//Hovering series
		chart.bodyLabelsHook = function (dp, moreSeriesPoint) {
			colorClass = (dp.open || dp.o) > (dp.close || dp.c) ? 'red' : 'green';
			const changeLabelColour = (dp.open || dp.o) > (dp.close || dp.c) ? '#EF5350' : '#32cd32';
			ohlcDiv.empty();
			ohlcDiv2.empty();
			ohlcDiv3.empty();
			ohlcDiv4.empty();
			ohlcDiv5.empty();

			var perC = ""; var chng = "";
			var chn = ""; var pChng = "";
			const is_ohlc = (dp.open || dp.o) && (dp.high || dp.h) && (dp.close || dp.c) && (dp.low || dp.l) && s.options  && s.options.type != 'line' && s.options.type != 'area'
			if(dp.options && dp.options.change) 
			{

				chng = dp.options.change.toFixed(cdata.nDecimals).toString()
				if(chng == 0 && (dp.options.change > 0 || dp.options.change < 0)){
					chng = dp.options.change.toFixed(6).toString()
				}

				if(Number(chng) > 0){
					chng = '+' + chng
				}				

				//chng = dp.change.toString().indexOf('-') != -1 ? dp.change.toFixed(cdata.nDecimals).toString() : '+' + dp.change.toFixed(cdata.nDecimals).toString();
				
				//fabio - if(chng > 0){
					//chn = '<span class="nChange nc1" style="color: #32cd32 "> '+chng+'</span>'
				//}else if(chng < 0){
					chn = '<span class="nChange nc1" style="color:' + (!is_ohlc? series[0].color : changeLabelColour) + '"> '+chng+'</span>'
				//}
			} else if (dp.change) {
				chng = dp.change.toFixed(cdata.nDecimals).toString()
				if(chng == 0 && (dp.change > 0 || dp.change < 0)){
					chng = dp.change.toFixed(6).toString()
				}
				if(Number(chng) > 0){
					chng = '+' + chng
				}
				chn = '<span class="nChange nc1" style="color:' + (!is_ohlc? series[0].color : changeLabelColour) + '"> '+chng+'</span>'
			}
			const isPercentage = checkIfPercentage(all_serires[0].full_name)
			if (dp.percentChange) 
			{
				perC = dp.percentChange.toString().indexOf('-') != -1 ? dp.percentChange.toFixed(2) : '+' + dp.percentChange.toFixed(2);
				//fabio - if(perC > 0){
					//pChng = '<span class="percChange" style="color:#32cd32 "> ('+perC+'%)</span>'

				//}else if(perC < 0){
					pChng = '<span class="percChange" style="color:' + (!is_ohlc? series[0].color : changeLabelColour) + '"> ('+ (!isPercentage? perC : chng)+'%)</span>'
				//}
			}

			if ((dp.open || dp.o) && (dp.high || dp.h) && (dp.close || dp.c) && (dp.low || dp.l) && s.options  && s.options.type != 'line' && s.options.type != 'area')
			{

				if(cdata.nDecimals == undefined){
					cdata.nDecimals = 7
				}
				var openLabelValue = (dp.open).toFixed(cdata.nDecimals) == 0  && (dp.open > 0 || dp.open < 0) ? (dp.open).toFixed(8) : (dp.open).toFixed(cdata.nDecimals)
				var highLabelValue = (dp.high).toFixed(cdata.nDecimals) == 0  && (dp.high > 0 || dp.high < 0) ? (dp.high).toFixed(8) : (dp.high).toFixed(cdata.nDecimals)
				var lowLabelValue = (dp.low).toFixed(cdata.nDecimals) == 0  && (dp.low > 0 || dp.low < 0) ? (dp.low).toFixed(8) : (dp.low).toFixed(cdata.nDecimals)
				var closeLabelValue = (dp.close).toFixed(cdata.nDecimals) == 0  && (dp.close > 0 || dp.close < 0) ? (dp.close).toFixed(8) : (dp.close).toFixed(cdata.nDecimals)
				
				if(isMobile){
					ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue  + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span><br>' + chn + pChng + ' </span>'));
				}else{
					ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue  + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span>&nbsp; ' + chn + pChng + ' </span>'));
				}
			}

			else if ((currentChartType == 'line' || currentChartType == 'area') || bodyLabelsMoreSeries)
			{
				if(all_serires.length === 1)
				{
					if(cdata.nDecimals == undefined){
						cdata.nDecimals = 7
					}

					var closeLabelValue = (dp.y).toFixed(cdata.nDecimals) == 0  && (dp.y > 0 || dp.y < 0) ? (dp.y).toFixed(8) : (dp.y).toFixed(cdata.nDecimals)				
					
					ohlcDiv.append($('<span class="ohlc_span ohlc_span_' + i + '">' + getChartTitleForLabel(s) + unit + '</span>')).append($('<span> <span class="closeLabel" style="color:' + series[0].color + '">' + closeLabelValue + '</span>&nbsp; ' + chn + pChng + ' </span>'));
				}
				else {
					if (all_serires.length == 2) {
						if (_th.chart.series.some(el => el.options.id.includes('diff_series'))){
							const diffSeriesIndex_1 = findSeriesIndex(_th.chart.series, 'diff_series_1')
							if (diffSeriesIndex_1 != -1) {
								const diff_point = _th.chart.series[diffSeriesIndex_1].data.find(diff_point => diff_point.x == dp.x)
								if (diff_point && diff_point.y != undefined) {
									let diff_value = diff_point.y.toFixed(3)
									if (diff_value > 0) {
										diff_value = '+' + diff_value
									}
									$('#diff_value').html(diff_value)
								}
							}

						}
					}
					if(bodyLabelsMoreSeries) {

						for(var i = 0; i < all_serires.length; i++)
						{
							if(all_serires[i] != undefined)
							{
								if (all_serires[i].iids.toLowerCase() == cdata.mainSymbol.toLowerCase())
								{
									var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									ohlcDiv.append($('<span><span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span></span>'));
								}

								if (cdata.secondSymbol) {
									if (all_serires[i].iids.toLowerCase() == cdata.secondSymbol.toLowerCase())
									{
										var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
										ohlcDiv2.append($('<div id="labelsDiv2" class="'+all_serires[i].iids+'"><span class="ohlc_span ohlc_span_' + i + '">' + nameId+ '</span></div>'));
									}
								}

								if(cdata.thirdSymbol)
								{
									if (all_serires[i].iids.toLowerCase() == cdata.thirdSymbol.toLowerCase())
									{
										var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
										ohlcDiv3.append($('<div id="labelsDiv3" class="'+all_serires[i].iids+'"><span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span></div>'));
									}
								}

								if(cdata.fourthSymbol)
								{
									if (all_serires[i].iids.toLowerCase() == cdata.fourthSymbol.toLowerCase())
									{
										var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
										ohlcDiv4.append($('<div id="labelsDiv4" class="'+all_serires[i].iids+'"><span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span></div>'));
									}
								}

								if(cdata.fifthSymbol)
								{
									if (all_serires[i].iids.toLowerCase() == cdata.fifthSymbol.toLowerCase())
									{
										var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
										ohlcDiv5.append($('<div id="labelsDiv5" class="'+all_serires[i].iids+'"><span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span></div>'));
									}
								}

								for (var a in moreSeriesPoint) {
									if(!moreSeriesPoint[a]) {
										continue
									}
									if(!moreSeriesPoint[a].series) {
										continue
									}

									if (all_serires[i].s == moreSeriesPoint[a].series.options.id) {
										try 
										{
											const isPercentage = checkIfPercentage(moreSeriesPoint[a].series.options.full_name)
											var hoverCompareSeriesClose = moreSeriesPoint[a].y != undefined ? moreSeriesPoint[a].y : moreSeriesPoint[a].y || ""

											if(hoverCompareSeriesClose !=""){
												if((hoverCompareSeriesClose < 0.010 && hoverCompareSeriesClose > 0) ||(hoverCompareSeriesClose > -0.010 && hoverCompareSeriesClose < 0))
												{
													hoverCompareSeriesClose = hoverCompareSeriesClose.toFixed(6)
												}else if(hoverCompareSeriesClose > 999){
													hoverCompareSeriesClose = hoverCompareSeriesClose.toFixed(2)
												}else{
													hoverCompareSeriesClose = hoverCompareSeriesClose.toFixed(3)
												}
											}
											if (!isPercentage) {
												if (all_serires[i].iids.toLowerCase() == cdata.mainSymbol.toLowerCase())
												{
													ohlcDiv.append($(' <span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].percentChange.toString().indexOf('-') != -1 ? moreSeriesPoint[a].percentChange.toFixed(2) : '+' + moreSeriesPoint[a].percentChange.toFixed(2))+'%)</span>'));
												}
												if (all_serires[i].iids.toLowerCase() == cdata.secondSymbol.toLowerCase())
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv2").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].percentChange.toString().indexOf('-') != -1 ? moreSeriesPoint[a].percentChange.toFixed(2) : '+' + moreSeriesPoint[a].percentChange.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv2").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}

												}
												if( all_serires[i].iids.toLowerCase() == cdata.thirdSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv3").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].percentChange.toString().indexOf('-') != -1 ? moreSeriesPoint[a].percentChange.toFixed(2) : '+' + moreSeriesPoint[a].percentChange.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv3").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
												if( all_serires[i].iids.toLowerCase() == cdata.fourthSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv4").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].percentChange.toString().indexOf('-') != -1 ? moreSeriesPoint[a].percentChange.toFixed(2) : '+' + moreSeriesPoint[a].percentChange.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv4").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
												if( all_serires[i].iids.toLowerCase() == cdata.fifthSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv5").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].percentChange.toString().indexOf('-') != -1 ? moreSeriesPoint[a].percentChange.toFixed(2) : '+' + moreSeriesPoint[a].percentChange.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv5").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
											} else {
												if (all_serires[i].iids.toLowerCase() == cdata.mainSymbol.toLowerCase())
												{
													ohlcDiv.append($(' <span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].change.toString().indexOf('-') != -1 ? moreSeriesPoint[a].change.toFixed(2) : '+' + moreSeriesPoint[a].change.toFixed(2))+'%)</span>'));
												}
												if (all_serires[i].iids.toLowerCase() == cdata.secondSymbol.toLowerCase())
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv2").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].change.toString().indexOf('-') != -1 ? moreSeriesPoint[a].change.toFixed(2) : '+' + moreSeriesPoint[a].change.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv2").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
												if( all_serires[i].iids.toLowerCase() == cdata.thirdSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv3").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].change.toString().indexOf('-') != -1 ? moreSeriesPoint[a].change.toFixed(2) : '+' + moreSeriesPoint[a].change.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv3").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
												if( all_serires[i].iids.toLowerCase() == cdata.fourthSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv4").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].change.toString().indexOf('-') != -1 ? moreSeriesPoint[a].change.toFixed(2) : '+' + moreSeriesPoint[a].change.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv4").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
												if( all_serires[i].iids.toLowerCase() == cdata.fifthSymbol.toLowerCase()) 
												{
													if (all_serires[i].type != 'te'){
														$("#labelsDiv5").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+(moreSeriesPoint[a].change.toString().indexOf('-') != -1 ? moreSeriesPoint[a].change.toFixed(2) : '+' + moreSeriesPoint[a].change.toFixed(2))+'%)</span>'));
													} else {
														$("#labelsDiv5").append($('<span class="closeLabel" style="color:' + series[i].color + '"> ' + hoverCompareSeriesClose + '</span>'));
													}
												}
											}
										}
										catch(err){ }
									}
								}
							}
						}
					}
				}
			}
		};

		var nameDiv = div({}, {
			'class': 'iChart-bodylabels-name'
		});

		var ohlcDiv = div({}, {
			'class': 'iChart-bodylabels-ohlc',
			'style': 'vertical-align: sub'
		});

		var ohlcDiv2 = div({}, {
			'class': 'iChart-bodylabels-ohlc',
			'style': 'vertical-align: sub'
		});

		var ohlcDiv3 = div({}, {
			'class': 'iChart-bodylabels-ohlc',
			'style': 'vertical-align: sub'
		});

		var ohlcDiv4 = div({}, {
			'class': 'iChart-bodylabels-ohlc',
			'style': 'vertical-align: sub'
		});

		var ohlcDiv5 = div({}, {
			'class': 'iChart-bodylabels-ohlc',
			'style': 'vertical-align: sub'
		});



		var colorClass = dataArr[dataArr.length - 1].open > dataArr[dataArr.length - 1].close ? 'green' : 'red',
			lastEle = dataArr[dataArr.length - 1];

		var unit = s.options.unit ? unit = " (" + s.options.unit + ")" : "";
		if (s.options.unit) {
			if (s.options.unit.toLowerCase() == "percent"  || s.options.unit.toLowerCase() == "index points") {
				unit = "";
			}
		}
		for (var i = 0; i < all_serires.length; i++) {
			if (all_serires.length === 1) {				
				//if(window.matchMedia("only screen and (max-width: 391px)").matches){
					if(isMobile){
						ohlcDiv.addClass("specialUniqueOhlc")
					}else{
						ohlcDiv.removeClass("specialUniqueOhlc")
					}
				ohlcDiv.append($('<span class="ohlc_span ohlc_span_' + i + '">' + getChartTitleForLabel(s) + unit + '</span>'));
				
			}
		}

		//need to get latest, live data
		if ((lastEle.open || lastEle.o) && s.options  && currentChartType != 'line' && currentChartType != 'area'){

			if(cdata.nDecimals == undefined){
				if(lastEle.y > 1){
					cdata.nDecimals = 3
				}else{
					cdata.nDecimals = 7
				}
			}

			var openLabelValue = (lastEle.open).toFixed(cdata.nDecimals) == 0  && (lastEle.open > 0 || lastEle.open < 0) ? (lastEle.open).toFixed(8) : (lastEle.open).toFixed(cdata.nDecimals)
			var highLabelValue = (lastEle.high).toFixed(cdata.nDecimals) == 0  && (lastEle.high > 0 || lastEle.high < 0) ? (lastEle.high).toFixed(8) : (lastEle.high).toFixed(cdata.nDecimals)
			var lowLabelValue = (lastEle.low).toFixed(cdata.nDecimals) == 0  && (lastEle.low > 0 || lastEle.low < 0) ? (lastEle.low).toFixed(8) : (lastEle.low).toFixed(cdata.nDecimals)
			var closeLabelValue = (lastEle.close).toFixed(cdata.nDecimals) == 0  && (lastEle.close > 0 || lastEle.close < 0) ? (lastEle.close).toFixed(8) : (lastEle.close).toFixed(cdata.nDecimals)
			//ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue  + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span>&nbsp; ' + chn + pChng + ' </span>'));
		
			if(isMobile){
				ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span><br><span class="' + colorClass + ' nChange nc2"></span> <span class="' + colorClass + ' percChange"> </span> </span>'));
			}else{
				ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span>&nbsp; <span class="' + colorClass + ' nChange nc2"></span> <span class="' + colorClass + ' percChange"> </span> </span>'));
			}
		} else if((currentChartType == 'line' || currentChartType == 'area') || bodyLabelsMoreSeries) {
			var change = ''; var perChange = '';
			if(all_serires.length === 1) {
				const isPercentage = checkIfPercentage(s.options.full_name)
				if(lastEle.change){
					if(cdata.nDecimals == undefined){
						if(lastEle.y > 1){
							cdata.nDecimals = 3
						}else{
							cdata.nDecimals = 7
						}
					}

					change = lastEle.change.toFixed(cdata.nDecimals);
					change = change.toString().indexOf('-') != -1 ? change.toString() : '+' + change.toString();
					colorClass = lastEle.change.toString().indexOf('-') != -1 ? 'red' : 'green'

				}
				if(lastEle.percentChange){
					perChange = lastEle.percentChange.toString().indexOf('-') != -1 ? lastEle.percentChange.toFixed(2) : '+' + lastEle.percentChange.toFixed(2);
					perChange = '(' + perChange + '%)';
				}
				if (isPercentage) {
					perChange = '(' + change + '%)';
				}
				if(cdata.nDecimals == undefined){
					cdata.nDecimals = 7
				}

				var closeLabelValue = ''
						if(lastEle.y){
							closeLabelValue = (lastEle.y).toFixed(cdata.nDecimals) == 0  && (lastEle.y > 0 || lastEle.y < 0) ? (lastEle.y).toFixed(8) : (lastEle.y).toFixed(cdata.nDecimals)
						}else if(lastEle.close){
							closeLabelValue = (lastEle.close).toFixed(cdata.nDecimals) == 0  && (lastEle.close > 0 || lastEle.close < 0) ? (lastEle.close).toFixed(8) : (lastEle.close).toFixed(cdata.nDecimals)
						}else if(lastEle.c){
							closeLabelValue = (lastEle.c).toFixed(cdata.nDecimals) == 0  && (lastEle.c > 0 || lastEle.c < 0) ? (lastEle.c).toFixed(8) : (lastEle.c).toFixed(cdata.nDecimals)
						}

				ohlcDiv.append($('<span> <span class="closeLabel" style="color:' + series[0].color + '">' + closeLabelValue + '</span>&nbsp;&nbsp; <span class="' + colorClass + ' nChange nc3">' + change + '</span> <span class="' + colorClass + ' percChange">' + perChange + '</span> </span>'));
			}
			else {
				if (bodyLabelsMoreSeries) {
					for (var i = 0; i < all_serires.length; i++) {
						try {
							var staticCompareSeriesClose = all_serires[i].data[all_serires[i].data.length-1].y != undefined ? all_serires[i].data[all_serires[i].data.length-1].y : all_serires[i].data[all_serires[i].data.length-1].y || ""

							if(staticCompareSeriesClose !=""){
								if((staticCompareSeriesClose < 0.010 && staticCompareSeriesClose > 0) ||(staticCompareSeriesClose > -0.010 && staticCompareSeriesClose < 0))
								{
									staticCompareSeriesClose = staticCompareSeriesClose.toFixed(6)
								}else if(staticCompareSeriesClose > 999){
									staticCompareSeriesClose = staticCompareSeriesClose.toFixed(2)
								}else{
									staticCompareSeriesClose = staticCompareSeriesClose.toFixed(3)
								}
							}

							if (all_serires[i].iids.toLowerCase() == cdata.mainSymbol.toLowerCase()) 
							{
								var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									ohlcDiv.append($('<span> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
							}

							if (cdata.secondSymbol) {
								if (all_serires[i].iids.toLowerCase() == cdata.secondSymbol.toLowerCase()) 
								{
									var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									labelsDiv2.addClass(all_serires[i].iids)
									if (all_serires[i].type != 'te'){
										ohlcDiv2.append($('<span id="labelsDiv2" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
									} else{
										ohlcDiv2.append($('<span id="labelsDiv2" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
									}
								}
							}

							if (cdata.thirdSymbol) {
								if (all_serires[i].iids.toLowerCase() == cdata.thirdSymbol.toLowerCase()) 
								{
									var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									labelsDiv3.addClass(all_serires[i].iids)
									if (all_serires[i].type != 'te'){
										ohlcDiv3.append($('<span id="labelsDiv3" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
									} else {
										ohlcDiv3.append($('<span id="labelsDiv3" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
									}

								}
							}

							if (cdata.fourthSymbol) {
								if (all_serires[i].iids.toLowerCase() == cdata.fourthSymbol.toLowerCase()) 
								{
									var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									labelsDiv4.addClass(all_serires[i].iids)
									if (all_serires[i].type != 'te'){
										ohlcDiv4.append($('<span id="labelsDiv4" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
									} else {
										ohlcDiv4.append($('<span id="labelsDiv4" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
									}
								}
							}

							if (cdata.fifthSymbol) {
								if (all_serires[i].iids.toLowerCase() == cdata.fifthSymbol.toLowerCase()) 
								{
									var nameId = all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									labelsDiv5.addClass(all_serires[i].iids)
									if (all_serires[i].type != 'te'){
										ohlcDiv5.append($('<span id="labelsDiv5" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
									} else {
										ohlcDiv5.append($('<span id="labelsDiv5" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
									}
								}
							}
						} 
						catch(err) { console.log("error", err); }
					}
				}
			}
		}

		$(".highcharts-root").on('mouseleave', function() {
			colorClass = lastEle.open > lastEle.close || lastEle.o > lastEle.c  ? 'red' : 'green'
			ohlcDiv.empty();
			ohlcDiv2.empty();
			ohlcDiv3.empty();
			ohlcDiv4.empty();
			ohlcDiv5.empty();
			if ($('#diff_value').is(':visible')){
				$('#diff_value').html('')
			}
			if ((lastEle.open || lastEle.o) && s.options && s.options.type != 'line' && s.options.type != 'area'){
				
				if(cdata.nDecimals == undefined){
					cdata.nDecimals = 7
				}

				var openLabelValue = (lastEle.open).toFixed(cdata.nDecimals) == 0  && (lastEle.open > 0 || lastEle.open < 0) ? (lastEle.open).toFixed(8) : (lastEle.open).toFixed(cdata.nDecimals)
				var highLabelValue = (lastEle.high).toFixed(cdata.nDecimals) == 0  && (lastEle.high > 0 || lastEle.high < 0) ? (lastEle.high).toFixed(8) : (lastEle.high).toFixed(cdata.nDecimals)
				var lowLabelValue = (lastEle.low).toFixed(cdata.nDecimals) == 0  && (lastEle.low > 0 || lastEle.low < 0) ? (lastEle.low).toFixed(8) : (lastEle.low).toFixed(cdata.nDecimals)
				var closeLabelValue = (lastEle.close).toFixed(cdata.nDecimals) == 0  && (lastEle.close > 0 || lastEle.close < 0) ? (lastEle.close).toFixed(8) : (lastEle.close).toFixed(cdata.nDecimals)
				//ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue  + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span>&nbsp; ' + chn + pChng + ' </span>'));
			
				if(isMobile){
					ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span><br><span class="' + colorClass + ' nChange nc2"></span> <span class="' + colorClass + ' percChange"> </span> </span>'));
				}else{
					ohlcDiv.append($('<span> O <span class="' + colorClass + ' openLabel">' + openLabelValue + '</span> H <span class="' + colorClass + ' highLabel">' + highLabelValue + '</span> L <span class="' + colorClass + ' lowLabel">' + lowLabelValue + '</span> C <span class="' + colorClass + ' closeLabel">' + closeLabelValue + '</span>&nbsp; <span class="' + colorClass + ' nChange nc2"></span> <span class="' + colorClass + ' percChange"> </span> </span>'));
				}
			
			}else if((currentChartType == 'line' || currentChartType == 'area') || bodyLabelsMoreSeries){
				if(all_serires.length === 1){
					$('.iChart-bodylabels-ohlc').removeClass("ohlcMinWidth");

					var change = ''; var perChange = "";
					if(s.options){
						const isPercentage = checkIfPercentage(s.options.full_name)
						if(lastEle.change){

							if(cdata.nDecimals == undefined){
								cdata.nDecimals = 7
							}
		
							change = lastEle.change.toFixed(cdata.nDecimals);

							change = change.toString().indexOf('-') != -1 ? change.toString() : '+' + change.toString();
							colorClass = lastEle.change.toString().indexOf('-') != -1 ? 'red' : 'green';
						}
						if(lastEle.percentChange){
							perChange = lastEle.percentChange.toString().indexOf('-') != -1 ? lastEle.percentChange.toFixed(2) : '+' + lastEle.percentChange.toFixed(2);
							perChange = '(' + perChange + '%)';
						}
						///////////
						if (!isNaN(last_socket_value)) {
							const dataLen = s.data.length
							let prevDataPoint = s.data[dataLen - 2]
							function setLabelDecimals1(value) {
								var val = Number(parseFloat(value).toFixed(5))
								if(val > 0.00001 && val < 0.009){
									val = Number(parseFloat(value).toFixed(6))
								}
								if (val > 10) {
									val = parseFloat(val).toFixed(3)
								}
								if (val > 100) {
									val = parseFloat(val).toFixed(2)
								}
								if (val > 1000) {
									val = parseFloat(val).toFixed(1)
								}
								if (val > 10000) {
									val = parseFloat(val).toFixed(0)
								}
								return val;
							}
			
							let valueToCalculation = prevDataPoint.y
			
							if(!valueToCalculation){
								prevDataPoint = s.data[dataLen - 3], 
								valueToCalculation = prevDataPoint.y
							}
			
							let chng = last_socket_value - valueToCalculation
							let fixedDecimals = 2;
							if(thisInterval.charAt(thisInterval.length - 1) === 'm'){
								fixedDecimals = 3
							}
							var perChange = -(((valueToCalculation-last_socket_value)/valueToCalculation) * 100).toFixed(fixedDecimals)
							if(perChange != 0){
								perChange = perChange.toString().indexOf('-') != -1 ? perChange.toString() : '+' + perChange.toString();
								perChange = '(' + perChange + '%)';
							}
							change = setLabelDecimals1(chng).toString().indexOf('-') != -1 ? setLabelDecimals1(chng).toString() : '+' + setLabelDecimals1(chng).toString();
						}
						//////////
						if (isPercentage) {
							perChange = '(' + change + '%)';
						}
						if(cdata.nDecimals == undefined){
							cdata.nDecimals = 7
						}

						var closeLabelValue = ''
						if(lastEle.y){
							closeLabelValue = (lastEle.y).toFixed(cdata.nDecimals) == 0  && (lastEle.y > 0 || lastEle.y < 0) ? (lastEle.y).toFixed(8) : (lastEle.y).toFixed(cdata.nDecimals)
						}else if(lastEle.close){
							closeLabelValue = (lastEle.close).toFixed(cdata.nDecimals) == 0  && (lastEle.close > 0 || lastEle.close < 0) ? (lastEle.close).toFixed(8) : (lastEle.close).toFixed(cdata.nDecimals)
						}else if(lastEle.c){
							closeLabelValue = (lastEle.c).toFixed(cdata.nDecimals) == 0  && (lastEle.c > 0 || lastEle.c < 0) ? (lastEle.c).toFixed(8) : (lastEle.c).toFixed(cdata.nDecimals)
						}
						ohlcDiv.append($('<span class="ohlc_span ohlc_span_' + i + '">' + getChartTitleForLabel(s) + unit +'</span>')).append($('<span> <span class="closeLabel" style="color:' + series[0].color + '">' + closeLabelValue + '</span>&nbsp; <span class="' + colorClass + ' nChange nc6">'+change+'</span> <span class="' + colorClass + ' percChange">'+perChange+'</span> </span>'));
//						ohlcDiv.append($('<span class="ohlc_span ohlc_span_' + i + '">' + getChartTitleForLabel(s) + unit + ' (UTC'+ localTimeZone +')</span>')).append($('<span> <span class="closeLabel" style="color:' + series[0].color + '">' + (lastEle.y || lastEle.close || lastEle.c || '').toFixed(cdata.nDecimals) + '</span>&nbsp; <span class="' + colorClass + ' nChange nc6">'+change+'</span> <span class="' + colorClass + ' percChange">'+perChange+'</span> </span>'));

					}
				}
				else {
					if (bodyLabelsMoreSeries) {
						$('.iChart-bodylabels-ohlc').addClass("ohlcMinWidth");

						for(var i = 0; i < all_serires.length; i++){

							try {
								var staticCompareSeriesClose = all_serires[i].data[all_serires[i].data.length-1].y != undefined ? all_serires[i].data[all_serires[i].data.length-1].y : all_serires[i].data[all_serires[i].data.length-1].y || ""

								if(staticCompareSeriesClose !=""){
									if((staticCompareSeriesClose < 0.010 && staticCompareSeriesClose > 0) ||(staticCompareSeriesClose > -0.010 && staticCompareSeriesClose < 0))
									{
										staticCompareSeriesClose = staticCompareSeriesClose.toFixed(6)
									}else if(staticCompareSeriesClose > 999){
										staticCompareSeriesClose = staticCompareSeriesClose.toFixed(2)
									}else{
										staticCompareSeriesClose = staticCompareSeriesClose.toFixed(3)
									}
								}

								if (all_serires[i].iids.toLowerCase() == cdata.mainSymbol.toLowerCase())
								{
									var nameId =all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
									
										ohlcDiv.append($('<span> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
									}

									if (cdata.secondSymbol) {
										if (all_serires[i].iids.toLowerCase() == cdata.secondSymbol.toLowerCase()) 
										{
											var nameId =all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
											if (all_serires[i].type != 'te'){
												ohlcDiv2.append($('<span id="labelsDiv2" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span>'));
											} else {
												ohlcDiv2.append($('<span id="labelsDiv2" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class=" closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
											}
									}
								}
	
									if (cdata.thirdSymbol) {
										if (all_serires[i].iids.toLowerCase() == cdata.thirdSymbol.toLowerCase()) 
										{
											var nameId =all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
											if (all_serires[i].type != 'te'){
												ohlcDiv3.append($('<div id="labelsDiv3" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span></div>'));
											} else {
												ohlcDiv3.append($('<div id="labelsDiv3" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
											}
									}
								}								
	
									if (cdata.fourthSymbol) {
										if (all_serires[i].iids.toLowerCase() == cdata.fourthSymbol.toLowerCase()) 
										{
											var nameId =all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
											if (all_serires[i].type != 'te'){
												ohlcDiv4.append($('<div id="labelsDiv4" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span></div>'));
											} else {
												ohlcDiv4.append($('<div id="labelsDiv4" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
											}
									}
								}
	
									if (cdata.fifthSymbol) {
										if (all_serires[i].iids.toLowerCase() == cdata.fifthSymbol.toLowerCase())
										{
											var nameId =all_serires[i].name.length < 25 ? all_serires[i].name : all_serires[i].iids.split(":")[0].toUpperCase();
											if (all_serires[i].type != 'te'){
												ohlcDiv5.append($('<div id="labelsDiv5" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span><span class="percChange" style="color:' + series[i].color + '"> ('+( all_serires[i].data[all_serires[i].data.length-1].percentChange != undefined ? ( all_serires[i].data[all_serires[i].data.length-1].percentChange.toString().indexOf('-') != -1 ? all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2) : '+' + all_serires[i].data[all_serires[i].data.length-1].percentChange.toFixed(2)) : "")+'%)</span></div>'));
											} else {
												ohlcDiv5.append($('<div id="labelsDiv5" class="'+all_serires[i].iids+'"> <span class="ohlc_span ohlc_span_' + i + '">' + nameId + '</span> <span class="closeLabel" style="color:' + series[i].color + '">' + staticCompareSeriesClose + '</span>'));
											}
									}
								}
						}
							catch(err) { console.error(err); }
						}
					}
				}
			}
		})

		if(isDarkMode == true){
			var pencilSvg = `<div class="dark-pencil-svg">${SVG_ICONS["pencil"]}</div>`
		}else{
			var pencilSvg = `<div class="pencil-svg">${SVG_ICONS["pencil"]}</div>`
		}

		//One series (&& compare)
		
		labelsDiv.append(nameDiv).append(ohlcDiv);
		if (nSeriesGlobal > 2) labelsDiv.append(pencilSvg);
		//Compare
		labelsDiv2.append(ohlcDiv2).append(pencilSvg);
		labelsDiv3.append(ohlcDiv3).append(pencilSvg);
		labelsDiv4.append(ohlcDiv4).append(pencilSvg);
		labelsDiv5.append(ohlcDiv5).append(pencilSvg);
		labelsDivx.append(labelsDiv).append(labelsDiv2).append(labelsDiv3).append(labelsDiv4).append(labelsDiv5)
		labelsDivx.show()
		labelsDiv.show();

		if (all_serires.length == 2) {
			labelsDiv2.show();
			//---------------
			labelsDiv3.hide();
			labelsDiv4.hide();
			labelsDiv5.hide();
		}

		if (all_serires.length == 3) {
			labelsDiv2.show();
			labelsDiv3.show();
			//---------------
			labelsDiv4.hide();
			labelsDiv5.hide();
		}

		if (all_serires.length == 4) {
			labelsDiv2.show();
			labelsDiv3.show();
			labelsDiv4.show();
			//---------------
			labelsDiv5.hide();
		}

		if (all_serires.length == 5) {
			labelsDiv2.show();
			labelsDiv3.show();
			labelsDiv4.show();
			labelsDiv5.show();
		}
	};
};

function buildChartMenu_controlBar() {
	var _this = this,
	    controlBar = {};

	var cBarWrapper = div({}, {'id':'control-bar-wrapper', 'class': 'iChart-control-bar-wrapper' }).hide();

	var cBarDiv = div({}, {
		'class': 'iChart-control-bar'
	});

	cBarWrapper.append(cBarDiv);
	_this.wrapper.append(cBarWrapper);
	_this.options['controlBar'] = controlBar;

	var zoomControlsDiv = div({}, {
		'class': 'iChart-zoomControl'
	})
	if(!isMobile){
		var controlElements = [ '-', '+', 'move_left', 'move_right', 'reset'];
	}else{
		var controlElements = ['move_left', 'move_right'];
	}

	function evokeEvent(element) {
		if (element.indexOf('move') > -1) {
			_this.events.moveAxis(element, 0.01);
		} else _this.events.zoom(element);
	};

	for (var ele in controlElements) {
		var element = controlElements[ele],
		    newDiv = div({}, {
			'class': 'iChart-control-bar-' + element + ' chartHoverZoomInOut',
		}, true).append(SVG_ICONS[element]);

		(function (element) {
			var timeoutRef = 0;
			newDiv.on('onkeydown', function () {
				evokeEvent(element);
			});

			newDiv.on('click', function () {
				evokeEvent(element);
			});

			newDiv.on('mousedown', function () {
				timeoutRef = setInterval(function () {
					evokeEvent(element);
				}, 200);
			});

			newDiv.on('mouseup mouseleave', function () {
				clearTimeout(timeoutRef);
			});

			zoomControlsDiv.append(newDiv);
		})(element);
	};

	cBarDiv.append(zoomControlsDiv);

	controlBar.update = function () {
		cBarWrapper.show();
		return;
	};
};

function buildAPIrequest(){
	var d1 = new Date(_th.chart.series[0].xData[0]).toISOString().slice(0,10)
	var d2 = new Date(_th.chart.series[0].xData[_th.chart.series[0].xData.length-1]).toISOString().slice(0,10)

	var series = Object.keys(_th.series).filter(function(value, index, arr){ 
		return value !='null:cur';
});

	var requestExport = 'https://api.tradingeconomics.com'
	if (_th.config.cdata.agr == '1m'  || _th.config.cdata.agr == '5m'|| _th.config.cdata.agr == '15m' || _th.config.cdata.agr == '1h'){
		requestExport += '/markets/intraday/'+series.join(',') + '?agr=' + _th.config.cdata.agr
		if(d1){
			requestExport += '&d1='+d1
		}
		if(d2){
			requestExport += '&d2='+d2 + ' ' + getCurrentUTCTime()

		}
	} else {
		requestExport += '/markets/historical/'+series.join(',')
	
		if(d1){
			requestExport += '?d1='+d1
		}
		if(d2){
			requestExport += '&d2='+d2
		
		}
	}
	

	return requestExport
}

function buildChartMenu_headerLabelsAdd(refCb) {

	var _this = this.menu,
		cdata = this.config.cdata;

	try{ if(log){ console.log('mkchart -> Config:', _this.config); } }catch(err){ console.log(err) }

	if (_this.config.compareButton === false) {
		return;
	}

	//COMPARE TOP BUTTON
	var btn = div({},
	{
		'id': isDarkMode == true ? 'dark-compareBtn' : 'compareBtn',
		'title':'Compare',
		'class': 'iChart-menu-btn-add iChart-header-option d-sm-none-down hover-bg-grey compareBtn d-none'
	}).on('click', function (e) {
		e.preventDefault();
		if (_th.config.cdata.compareNumber >= 5) {
			return
		}
		_th.chart.navigationBindings.deselectAnnotation()

		var options1 = $(".optionsY-y_axis_main")
		var options2 = $(".optionsY-y_axis_2")
		var compareButton = $(this);
		var headerButtons = $('.header-buttons');

		$('#downloadBtn').hide()
		$('#dark-downloadBtn').hide()
		headerButtons.hide();
		compareButton.hide();
		options1.hide();
		options2.hide();
		input.show().focus();
		$('#eventsBtn').hide()
		$('#dark-eventsBtn').hide()
		$("#fullscreenBtn").hide();
		$("#dark-fullscreenBtn").hide();
		$('#superMenuBtn').hide()
		$('#dark-superMenuBtn').hide()
		compareButton.addClass('compareBtnActive')
		$('.topnav-left-group').hide()
		$("#exportBtn").hide();
		$("#dark-exportBtn").hide();
	});

	$(document).on("click", function(event){
		if(!$(event.target).closest($(".compareButtonInput")).length && $(".iChart-dpMenu-typeahead").is(':visible') && event.target.id !== ('expandedSearchBarBoxId') && event.target.id !== ('compareButtonInputId')){
			$('#downloadBtn').show()
			$('#dark-downloadBtn').show()
			$('#compareBtn').show()
			$('#dark-compareBtn').show()
			$('.header-buttons').show()
			$('#eventsBtn').show()
			$('#dark-eventsBtn').show()
			$("#fullscreenBtn").show();
			$("#dark-fullscreenBtn").show();
			$('#dark-superMenuBtn').show()
			$('#superMenuBtn').show()
			$('.compareBtn').removeClass('compareBtnActive')
			$('.topnav-left-group').show()
			$("#exportBtn").show();
			$("#dark-exportBtn").show();
		}
});
	$(document).on("keyup", function(event){
		if (event.key === "Escape" && $(".compareButtonInput").is(':visible')) {
			$('#downloadBtn').show()
			$('#dark-downloadBtn').show()
			$('#compareBtn').show()
			$('#dark-compareBtn').show()
			$('.header-buttons').show()
			$('#eventsBtn').show()
			$('#dark-eventsBtn').show()
			$("#fullscreenBtn").show();
			$("#dark-fullscreenBtn").show();
			$('#dark-superMenuBtn').show()
			$('#superMenuBtn').show()
			$('.compareBtn').removeClass('compareBtnActive')
			plotEvents = false;
			$('.topnav-left-group').show()
			$("#exportBtn").show();
			$("#dark-exportBtn").show();
		}
	})

	var icon = $('<span class="header-buttons" style="transform:translate(-8%,-10%)"></span>').append(`${!isMobile? SVG_ICONS[/*'plus'*/'add_box'] : SVG_ICONS['add_box_mobile']}`),
	    addBtn = {};
  
			if(isDarkMode == true){ icon.addClass("dark-svg")}

	addBtn.cnt = btn;
	addBtn.update = function () {
		return;
	};

	btn.append(icon);

	_this.options['Add'] = addBtn;
	// _this.cnt.append(btn); /*REMOVED COMPARE BUTTON*/
	$('.topnav-flex-container').append(btn)
	//ADD EVENTS BUTTON
	if (!isMobile) {
		let eventsBtn = div({},
			{
				'id': isDarkMode == true ? 'dark-eventsBtn' : 'eventsBtn',
				'title':'Plot events',
				'class': 'iChart-header-option d-sm-none-down hover-bg-grey eventsBtn'
			}).on('click', function (e) {
				e.preventDefault();
				if (_th.config.cdata.compareNumber > 1 || flagCount >= 4) {
					return
				}
				_th.chart.navigationBindings.deselectAnnotation()
				plotEvents = true;
				var options1 = $(".optionsY-y_axis_main")
				var options2 = $(".optionsY-y_axis_2")
				var eventsButton = $(this);
				var compareButton = $(".compareBtn")
				var compareInpute = $(".compareButtonInput");
				var headerButtons = $('.header-buttons');
		
				$('#downloadBtn').hide()
				$('#dark-downloadBtn').hide()
				//$('#iChartHeader-annotationPicker-button').hide()
				//$('#dark-drawBtn').hide()
				//$('#drawHBtn').hide()
				//$('#dark-drawHBtn').hide()
				compareButton.hide()
				headerButtons.hide();
				eventsButton.hide();
				options1.hide();
				options2.hide();
				input.show().focus();
				$("#fullscreenBtn").hide();
				$("#dark-fullscreenBtn").hide();
		
				compareInpute.focusout(function () {
					$('#downloadBtn').show()
					$('#dark-downloadBtn').show()
					headerButtons.show();
					compareButton.show();
					eventsButton.show()
					$("#fullscreenBtn").show();
					$("#dark-fullscreenBtn").show();
					$('#dark-superMenuBtn').show()
					$('#superMenuBtn').show()
				});
			});
		let eventsIcon = $('<span class="header-buttons"></span>').append(SVG_ICONS['events_new']);
		let eventsCtrlBtn = {};
	  
		if(isDarkMode == true){ eventsIcon.addClass("dark-svg")}
	
		eventsCtrlBtn.cnt = eventsBtn;
		eventsCtrlBtn.update = function () {
			return;
		};
		eventsBtn.append(eventsIcon);
		_this.options['Events'] = eventsCtrlBtn;
	}
	// SUPER MENU BUTTON
	const superMenuBtn = div({}, {
		'id': isDarkMode == true ? 'dark-superMenuBtn' : 'superMenuBtn',
		'title':'Options',
		'class': 'iChart-menu-btn-superMenu d-sm-none-down iChart-header-option hover-bg-grey superMenuBtn'
	}).on('click', function (e) {
		e.preventDefault();
		const options1 = $(".optionsY-y_axis_main")
		const options2 = $(".optionsY-y_axis_2")
		options1.hide();
		options2.hide();
		if (!$('.superMenuDropdown')[0]) {
			// const left = isDarkMode == true ? $('#dark-superMenuBtn').offset().left : $('#superMenuBtn').offset().left
			const left = document.getElementById('superMenuIcon').getBoundingClientRect().left
			const leftOffset = !isFS? left - document.getElementById('trading_chart').getBoundingClientRect().left : left
			const width = isDarkMode? $('#dark-superMenuBtn').width() : $('#superMenuBtn').width()
			const leftPos = leftOffset - width/2
			//create a div for the dropdown
			const superMenuDropdown = div({}, {
				'id': 'superMenuDropdown',
				'class': isDarkMode == true ? 'iChart-dpMenu-cnt superMenuDropdown darkSubMenu' : 'iChart-dpMenu-cnt superMenuDropdown',
				'style':`display:block; left:${leftPos}px;`
			})
			if(!isMobile){
			// add events
			const eventsMenuOption = $(`<a id="eventsMenuOption" class ="superMenuOption"><span class="${isDarkMode? 'dark-svg' : ''}">${SVG_ICONS['events_new']}</span><span>Events</span></a>`).click(function(e){
				e.preventDefault();
				ga('event', 'te_chart_markets_events');
				if (_th.config.cdata.compareNumber > 1 || flagCount >= 4) {
					return
				}
				_th.chart.navigationBindings.deselectAnnotation()
				const headerButtons = $('.header-buttons');
				$('#downloadBtn').hide()
				$('#dark-downloadBtn').hide()
				headerButtons.hide();
				input.show().focus();
				$("#fullscreenBtn").hide();
				$("#dark-fullscreenBtn").hide();
				$('#dark-superMenuBtn').hide()
				$('#superMenuBtn').hide()
				$('.superMenuDropdown').remove()
				$('#compareBtn').hide()
				$('#dark-compareBtn').hide()
				plotEvents = true;
				$('.topnav-left-group').hide()
				$("#exportBtn").hide();
				$("#dark-exportBtn").hide();
			})
			if (_th.config.cdata.compareNumber > 1 || flagCount >= 4) {
				eventsMenuOption.addClass('disabled')
			}

			superMenuDropdown.append(eventsMenuOption)
			let types = []
			if (_th.config.cdata.compareNumber == 1) {
				types = ['trendline', 'horizontal line', 'vertical line', 'text annotation', 'SMA']
			} else if (_th.config.cdata.compareNumber == 2) {
				types = ['trendline', 'horizontal line', 'vertical line', 'text annotation', 'series difference']//Fabio September 2023 - Need  Review, 'series difference']
			} else {
				types = ['trendline', 'horizontal line', 'vertical line', 'text annotation'];
			}
			for (let i = 0; i < types.length; i++) {
				var a = $('<a title="Draw '+ types[i] +'" data-type="' + types[i] + '" class="techIndOption"><span>' + SVG_ICONS[types[i]] + '</span><span>' + capitaliseString(types[i]) +'</span></a>').on('click', function (e) {
					e.preventDefault();	

					if($(this).attr('data-type') === 'trendline') {
							var a = $(".highcharts-segment");
							a.click();
							$("#iChartHeader-annotationPicker-button").addClass("draw-trendline-active")
							$("#control-bar-wrapper").css("display","none")
							_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});
							ga('event', 'te_chart_markets_technical_trendline')
					}else if($(this).attr('data-type') === 'horizontal line'){
						e.preventDefault()
						$('.superMenuDropdown').hide()
						ga('event', 'te_chart_markets_technical_horizontalline')
						_th.chart.navigationBindings.deselectAnnotation()
						if($(".draw-horizontalline-active").is(":visible")){
							$("#iChartHeader-annotationPicker-button").removeClass("draw-horizontalline-active")
							$('.iChart-chart').css('cursor','default')	
							$("#control-bar-wrapper").css("display","block")
						}else{
							$('.iChart-chart').css('cursor','crosshair')	
							$("#iChartHeader-annotationPicker-button").addClass("draw-horizontalline-active")
							$("#control-bar-wrapper").css("display","none")
						}
						_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});
					}else if($(this).attr('data-type') === 'vertical line'){
						e.preventDefault()
						$('.superMenuDropdown').hide()
						ga('event', 'te_chart_markets_technical_verticalline')
						_th.chart.navigationBindings.deselectAnnotation()
						if($(".draw-verticalline-active").is(":visible")){
							$("#iChartHeader-annotationPicker-button").removeClass("draw-verticalline-active")
							$('.iChart-chart').css('cursor','default')	
							$("#control-bar-wrapper").css("display","block")
						}else{
							$('.iChart-chart').css('cursor','crosshair')	
							$("#iChartHeader-annotationPicker-button").addClass("draw-verticalline-active")
							$("#control-bar-wrapper").css("display","none")
						}
						_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});		
							_th.chart.redraw()
					} else if ($(this).attr('data-type') === 'text annotation') {
						$("#iChartHeader-annotationPicker-button").addClass("draw-textannotation-active")
						$("#control-bar-wrapper").css("display","none")
						let a = $(".highcharts-label-annotation")
						a.click();
						ga('event', 'te_chart_markets_technical_textannotation')
					} else if($(this).attr('data-type') === 'SMA') {
						$('.superMenuDropdown').hide()
						if (smaCount >= 4) {
							return
						}
						indicatorChoosen = "sma";
						if (!$(".iChart-tech-indicators-modal")[0]){
							buildTechIndicatorsModal()
						}
						$('.techIndicatorModalTitle').html('Simple Moving Average <br/>')
						$(".iChart-tech-indicators-modal").show();
						ga('event', 'te_chart_markets_technical_sma')
					} else if ($(this).attr('data-type') === 'series difference') {
						if ($("#diffLabels").is(":visible")) {
							return
						}
						differenceSeries = true
						for (let i in _th.chart.series)
						{
							if (_th.chart.series[i].userOptions.id != "null:cur")
							{
								const thisIndex = _th.chart.series[i].index;
		
								_th.chart.series[thisIndex].update({
									yAxis: 'y_axis_main'
								});
								saveUserSelections[_th.chart.series[i].userOptions.id].yaxis = 'y_axis_main';
		
							}
						}
						neutralAxisMargin= false;
						mainAxisMargin= false;
						secondaryAxisMargin = false;
			
						for(let checkSerie of _th.chart.series){
							if(checkSerie.options.id != 'null:cur'){
								if(checkSerie.options.yAxis == 'y_axis_main'){ mainAxisMargin = true};
								if(checkSerie.options.yAxis == 'y_axis_2'){secondaryAxisMargin = true};
								if(checkSerie.options.yAxis == 'yaxis_n') {neutralAxisMargin = true};
							}		
						}
						skipAPI = true
						_th.fireEvent('onOptionsChange');
		
						_th.build(function () {
							updateChartMenu.call(_th);
						});
						const diff_series = calculateDiff(_th.chart.series[0].data, _th.chart.series[1].data)
						const diff_colour = '#4ecdc4'
						const diff_options = {
							type: 'column',
							data: diff_series,
							id: 'diff_series_1',
							index: 2,
							dataGrouping: {
								enabled: false
							},
							color: diff_colour,
						}
						
						_th.chart.addSeries(diff_options)
						diff_options["visible"] = false
						diff_options["id"] = 'diff_series_2'
						_th.chart.addSeries(diff_options)
						_th.chart.redraw()
						//Label
						if (!$("#diffLabels")[0]){
							($('<div id="diffLabels"></div>')).insertAfter("#iChart-bodyLabels-cntx")
						}
						const diffLabel = $('<span id="diff_label_span" class="diffLabel"></span>')
						diffLabel.append($(`<span class="diffLabelColour" id="diff_colour" style="background-color:${diff_colour};"></span>`))
						diffLabel.append($(`<span class="diffLabelDesc" id="diff_label" style="color:${diff_colour};">Series difference</span>`))
						diffLabel.append($(`<span class="diffLabelValue" id="diff_value" style="color:${diff_colour};"></span>`))
						diffLabel.append($(`<span class="removeDiff" id="diff_remove_icon">${SVG_ICONS['cross']}</span>`).click(function(){
							const diffSeriesIndex_1 = findSeriesIndex(_th.chart.series, 'diff_series_1')
							_th.chart.series[diffSeriesIndex_1].remove()
							const diffSeriesIndex_2 = findSeriesIndex(_th.chart.series, 'diff_series_2')
							_th.chart.series[diffSeriesIndex_2].remove()
							$("#diffLabels").remove()
							differenceSeries = false
							chartTitle(_th.chart.series)
						}))
				
						$("#diffLabels").append(diffLabel)
						ga('event', 'te_chart_markets_technical_seriesdifference')
					}
					$('.annotationsDropdown').remove()		
				});
				if(isDarkMode == true){
					a.addClass('dark-svg')
				}
				if (types[i] == 'SMA' && smaCount >= 4) {
					a.addClass('disabled')
				}
				if (types[i] == 'series difference' && $("#diffLabels").is(":visible")) {
					a.addClass('disabled')
				}
				superMenuDropdown.append(a);
			}

		}
			$('.iChart-headerMenu2').append(superMenuDropdown)
		} else {
			$('.superMenuDropdown').remove()
			$('.annotationsDropdown').remove()
		}
	});
	const superMenuBtnIcon = $('<span id="superMenuIcon" class="header-buttons"></span>').append('<i class="bi bi-wrench"></i>');
	const superMenuCtrlBtn = {};
	
	if(isDarkMode == true){ superMenuBtnIcon.addClass("dark-svg")}
	
	superMenuCtrlBtn.cnt = superMenuBtn;
	superMenuCtrlBtn.update = function () {
		return;
	};
	superMenuBtn.append(superMenuBtnIcon);
	_this.options['SuperMenu'] = superMenuCtrlBtn;
	// _this.cnt.append(superMenuBtn)
	$('.topnav-flex-container').append(superMenuBtn)
	$(document).on("click", function(e){
		const superBtnElement = isDarkMode? document.getElementById('dark-superMenuBtn') : document.getElementById('superMenuBtn');
		const dropdownElement = document.getElementById('superMenuDropdown');
		if (dropdownElement) {
			if (e.target !== superBtnElement && !superBtnElement.contains(e.target) && e.target !== dropdownElement && !dropdownElement.contains(e.target)) {
				$('.superMenuDropdown').remove()
			}
		} else {
			if (e.target !== superBtnElement && !superBtnElement.contains(e.target)) {
				$('.superMenuDropdown').remove()
			}
		}
	})
	//EXPORT TOP BUTTON
	var exportBtn = div({},
		{
			'id': isDarkMode == true ? 'dark-exportBtn' :'exportBtn' ,
			'title':'Download',
			'class': isDarkMode == true ? 'iChart-menu-btn-export topnav-right-group iChart-header-option-export dark-svg' : 'iChart-menu-btn-export topnav-right-group iChart-header-option-export'
		})
	
		exportBtn.append($(`${!isMobile? SVG_ICONS['three_dots_vertical'] : SVG_ICONS['three_dots_vertical_mobile']}`/*'<svg class="exportingBtnSvg" viewBox="0 0 20 20"><path d="M3.936,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021S5.957,11.116,5.957,10S5.052,7.979,3.936,7.979z M3.936,11.011c-0.558,0-1.011-0.452-1.011-1.011s0.453-1.011,1.011-1.011S4.946,9.441,4.946,10S4.494,11.011,3.936,11.011z M16.064,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021s2.021-0.905,2.021-2.021S17.181,7.979,16.064,7.979z M16.064,11.011c-0.559,0-1.011-0.452-1.011-1.011s0.452-1.011,1.011-1.011S17.075,9.441,17.075,10S16.623,11.011,16.064,11.011z M10,7.979c-1.116,0-2.021,0.905-2.021,2.021S8.884,12.021,10,12.021s2.021-0.905,2.021-2.021S11.116,7.979,10,7.979z M10,11.011c-0.558,0-1.011-0.452-1.011-1.011S9.442,8.989,10,8.989S11.011,9.441,11.011,10S10.558,11.011,10,11.011z"></path></svg>'*/).click(function(){
			_th.chart.navigationBindings.deselectAnnotation()
			if(!$('#exportMenu')[0]){
				var exportMenu = div({},
					{
						'id': 'exportMenu' ,
						'class': isDarkMode == true ? 'iChart-dpMenu-cnt exportImage-cnt darkSubMenu' : 'iChart-dpMenu-cnt exportImage-cnt',
						'style':'display:block'
					})
				
					var fullScreen = $("<a id='fullscreen' class='fullscreen'>View in full screen</a>").on('click',function(){
						if (isFS == false) {
							var _this_a = $(".iChart-wrapper")[0];
							requestFullScreen.call(this, _this_a);
						} else if (isFS == true) {
							cancelFullScreen.call();
						}
						if (all_serires.length == 2) {
							$(".ohlc_span ohlc_span_0").show();
						}
						$('#exportMenu').hide()
					})
					
					var exportPNG = $("<a id='downloadPng' class='downloadPng'>PNG image</a>").on('click',function(){
						_th.cleanSeriesExport({type: 'image/png'})
						ga('event', 'te_chart_markets_exportimage')
						$('#exportMenu').hide()
					})
					var exportPDF = $("<a id='downloadPdf' class='downloadPdf'>PDF document</a>").on('click',function(){
					_th.cleanSeriesExport({type: 'application/pdf'});
					ga('event', 'te_chart_markets_exportimage')
						$('#exportMenu').hide()
					})
					var exportSVG = $("<a id='downloadCsv' class='downloadCsv'>SVG vector image</a>").on('click',function(){
						_th.cleanSeriesExport({type: 'image/svg+xml'});
						ga('event', 'te_chart_markets_exportimage')
						$('#exportMenu').hide()
					})
					exportMenu.append(exportPNG, exportPDF, exportSVG)

					_this.wrapper.append(exportMenu)
			}else{
				if($('#exportMenu').is(":visible")){
					$('#exportMenu').hide()
				}else{
					$('#exportMenu').show()
					//ga('event', 'te_chart_markets_exportimage')
				}
			}
		
		}));
		
		$(document).on('click', function (e) {
			var targetEle = $(e.target);
			if ((!targetEle[0].classList.value.includes('exportImage-cnt') && !targetEle[0].classList.value.includes('exportingBtnSvg') && !targetEle[0].outerHTML.includes(/*'d="M3.936,7.979c-1.116,0-2.021,0'*/'M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1')) || targetEle[0].className == 'iChart-headerMenu2' || targetEle[0].localName == 'body'  || targetEle[0].id == 'aspnetForm') {
				$('#exportMenu').hide()	
			}
		});

		// _this.cnt.append(exportBtn);

		//DOWNLOAD TOP 
		const  downloaBtnClassForIOS = !notIOS ? 'unsetTransform' : ''
		var downloadBtn = div({},
			{
				'id': isDarkMode == true ? 'dark-downloadBtn' : 'downloadBtn',
				'class': isDarkMode == true ? 'iChart-menu-btn-download topnav-right-group iChart-header-option-download dark-svg ' + downloaBtnClassForIOS : 'iChart-menu-btn-download topnav-right-group iChart-header-option-download ' + downloaBtnClassForIOS,
				'title': 'Export Data'
			})
	
			downloadBtn.append($(`${!isMobile? SVG_ICONS[/*'download_data'*/'cloud_download'] : SVG_ICONS['cloud_download_mobile']}`).click(function(){
				_th.chart.navigationBindings.deselectAnnotation()
				if(TEUserInfo == undefined && TEUsername == undefined){
					$('a[data-download="csv"]').click();
					try{
						// ga('send', 'event', 'Data Request', 'Chart Export', 'Market');
						ga('event', 'te_chart_markets_export');
					}catch(e){
						console.log("Something wrong with Google Analytics function")
						console.log(e)
					}
				}else{
					const left = isDarkMode? document.getElementById('dark-downloadBtn').getBoundingClientRect().left : document.getElementById('downloadBtn').getBoundingClientRect().left
					const leftOffset = !isFS? left - document.getElementById('trading_chart').getBoundingClientRect().left : left
					const leftPos = window.innerWidth > 480? leftOffset - 40 : leftOffset - 48
					if(!$('#downloadMenu')[0]){
						var downloadMenu = div({},
							{
								'id': 'downloadMenu' ,
								'class': isDarkMode == true ? 'iChart-dpMenu-cnt dark-downloadData-cnt ' : 'iChart-dpMenu-cnt downloadData-cnt',
								'style': `left:${leftPos}px;`
							})
							var requestURL = buildAPIrequest()
							
							var exportCSV = $("<a id='exportCsv' href='" + requestURL + "&format=csv"  + "'>Export CSV</a>").on('click',function(){
								$('#downloadMenu').css('display','none')
							})
							
							var exportJSON = $("<a id='exportJson' href='"+ requestURL + "&format=json" + "' target='_blank' rel='noopener noreferrer'>Export JSON</a>").on('click',function(){
								$('#downloadMenu').css('display','none')
							})
						
							downloadMenu.append(exportCSV, exportJSON)

							_this.wrapper.append(downloadMenu)
					}else{
						if($('#downloadMenu').is(":visible")){
							$('#downloadMenu').css('display','none')
						}else{
							$('#downloadMenu').css('display','block')
							$('#downloadMenu').css('left', leftPos + 'px')
							var requestURL = buildAPIrequest()
							$('#exportJson').attr("href", requestURL+"&format=json")
							$('#exportCsv').attr("href", requestURL+"&format=csv")
						}
					}
					}
					
			}));
			
			$(document).on('click', function (e) {
			var targetEle = $(e.target);
			if (!targetEle[0].classList.value.includes('downloadArrow') && !targetEle[0].classList.value.includes('svg-icon') && !targetEle[0].classList.value.includes('iChart-menu-btn-download ') && !targetEle.text().includes(/*'d="M38.71 20.07c-1.36-6'*/'d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11') && !targetEle.text().includes('d="M19.35,10.04C18.67,6.59,15.64,4,12,4C9.11,4,6.')) {
				$('#downloadMenu').css('display','none')	
			}
		});

			// _this.cnt.append(downloadBtn);
		$('.topnav-flex-container').append(downloadBtn)
	
	//FULL SCREEN BUTTON
	if(notIOS){
		const fullscreenBtn = div({},
			{
				'id': isDarkMode == true ? 'dark-fullscreenBtn' : 'fullscreenBtn',
				'class': isDarkMode == true ? 'iChart-header-option topnav-right-group d-sm-none-down hover-bg-grey fullscreenBtn dark-svg' : 'iChart-header-option topnav-right-group d-sm-none-down hover-bg-grey fullscreenBtn',
				'title': 'View in full screen'
			})
		fullscreenBtn.append($(`${!isMobile? SVG_ICONS['fullscreen'] : SVG_ICONS['fullscreen_mobile']}`)).click(function() {
			if (isFS == false) {
				let _this_a = $(".iChart-wrapper")[0];
				requestFullScreen.call(this, _this_a);
			} else if (isFS == true) {
				cancelFullScreen.call();
			}	
		})
		// _this.cnt.append(fullscreenBtn)
		$('.topnav-flex-container').append(fullscreenBtn)
	}
	$('.topnav-flex-container').append(exportBtn)
	//Search Input for Compare
	var inputIsHover = false

	if(isDarkMode == true){
		var input = $('<input id="compareButtonInputId" class="compareButtonInput dark-searchInput" type="text" placeholder="Search..." >')
	}else{
		var input = $('<input id="compareButtonInputId" class="compareButtonInput searchInput" type="text" placeholder="Search..." >')
	}

	input.hide().hover(function () {
		inputIsHover = true;
	}, function () {
		inputIsHover = false;
	})

	var dp = div({}, {
		'class': isDarkMode == true ? 'thin scrollbar-black bordered-black iChart-dpMenu-typeahead darkTopWrapper' : 'thin scrollbar-black bordered-black iChart-dpMenu-typeahead'
	});

	$(document).keyup(function(e) {
		if (e.key === "Escape") {
			input.hide();
	   }
   });

	var pos = _this.calcDropDownPos(btn, dp);

	dp.css(pos);

	if(isDarkMode == true){
		input.insertAfter($("#dark-superMenuBtn"));
	}else{
		input.insertAfter($("#superMenuBtn"));
	}

	_this.wrapper.closest('.iChart-wrapper').append(dp);
	input.typeahead({
		cnt: dp,
		url: 'https://brains.tradingeconomics.com/v2/search/forex,bond,idx,commodity,mkt,economy,economic?q=',
		context: _this.context,
		replace: function replace(url, value) {
			var secondURLPart = '&pp=5&mkchart=1&p=0&_=1566570083316&stance=2'	
			if (plotEvents) {
				url = 'https://brains.tradingeconomics.com/v2/search/economy,economic?q='
				secondURLPart = '&pp=5&mkchart=1&p=0&_=1566570083316&stance=2&hascalendar=1'
				if(TECountry == '' || TECountry== 'Commodity') TECountry = 'United States'
			}	
			value ? value = value : plotEvents?  value = TECountry.replace(' ', '%20') : value = symbol;
			return url + value + secondURLPart;
		},
		onSelect: async function onSelect(val) {
			if (plotEvents) {
				let eventSymbol = val.split(":te")[0].replace(' ', '%20')
				let span = cdata.span.toLowerCase()
				let time_period = '';
				if (_th.config.cdata.d1 && _th.config.cdata.d2 && _th.config.cdata.d1 != null && _th.config.cdata.d2 != null) {
					time_period = `&d1=${_th.config.cdata.d1}&d2=${_th.config.cdata.d2}`
				} else {
					time_period = `&span=${span}`
				}
				time_period = time_period.slice(1)
				let requestUrlStr = `https://d3ii0wo49og5mi.cloudfront.net/events/${eventSymbol}?${time_period}&securify=new&url=${TESecurifyUrl}&AUTH=${TESecurify}`;
				
				const isEPS = val.slice(-4).toLowerCase() == ':eps' ? true : false
				if (isEPS) {
						requestUrlStr = `https://d3ii0wo49og5mi.cloudfront.net/economics/${val}?${time_period}&securify=new&url=${TESecurifyUrl}&AUTH=${TESecurify}`
				}
				console.log(requestUrlStr);
				let response = await fetch(requestUrlStr)
				let result = await response.json()
				if (result.length < 1) {
					plotEvents = false;
					return
				}
				if (result[0].series.length < 1) {
					plotEvents = false;
					return
				}
				if (!result[0].series[0].serie) {
					plotEvents = false;
					return
				}
				if (!result[0].series[0].serie.data) {
					plotEvents = false;
					return
				}
				if (result[0].series[0].serie.data.length < 1) {
					plotEvents = false;
					return
				}
				let eventsData = []
				if(isEPS){
					eventsData = [...transformData('earnings', earnings_structure_array, result[0].series[0].serie.data)];
				}else{
					eventsData = [...transformData('calendar', calendar_structure_array, result[0].series[0].serie.data)];
				}
				let flagColour = flagsColourArr.shift();

				flagCount++;
				flagSeriesArr.push(val)
				let checkAdditionalEventsIndex = -1
				for (let i = 0; i < additionalEvents.length; i++) {
					if (additionalEvents[i].s == val) {
						checkAdditionalEventsIndex = i
						break
					}
				}
				console.log("addevents index");
				console.log(val);
				console.log(additionalEvents);
				if (checkAdditionalEventsIndex > -1) {
					console.log("splice");
					additionalEvents.splice(checkAdditionalEventsIndex, 1)
					console.log(additionalEvents);
				}
				let options = {
					point: {events: {
						mouseOver: function () {
							addTooltip(this.options.text, this.plotX, this.plotY, this.color)
						},
						mouseOut: function () {
							const element = document.getElementById("flag_tooltip");
							if (element) {
								element.remove();
							}
						}
    				},},
					type: 'flags',
					isEPS: isEPS,
					category: eventsData[0].category || "",
					country: eventsData[0].country || "",
					name: result[0].series[0].serie.shortname || result[0].series[0].serie.name || "",
					data: [],
					id: 'flags_' + val,
					index: 1,
					symbol: val,
					zIndex: 99,
					height: 10,
					includeInDataExport: true,
					color: flagColour,
					fillColor: flagColour,
					onSeries: _th.series[Object.keys(_th.series)[0]].config.id,	
					tooltip: {
							enabled: false
					},
					shape: 'square',
					style: {
							color: isDarkMode? "black" :"white",
							border: flagColour,
					},
					states: {
							hover: {
								fillColor: flagColour,
								border: flagColour,
								lineColor: flagColour,
							}
					},
					events: {
						click: function(e) {
							e.preventDefault();
						}
					},
					allowOverlapX: true,
				}
				eventsData.forEach((currentEvent, index) => {
					if (isEPS && index == 0) {
						if (currentEvent.x < _th.chart.series[0].data[0].x) {
							return
						}
					}
					//console.log(currentEvent);
					let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }
					let currentEventDate = new Date(currentEvent.date).toLocaleDateString(undefined, dateOptions)
					let currentEventText = currentEvent.event_name
					let actual = currentEvent.actual
					let forecast = currentEvent.forecast
					let country = currentEvent.country
					const close = currentEvent.close
					const refDate = currentEvent.referenceDate
					const name = result[0].series[0].serie.shortname || result[0].series[0].serie.name || ""
					let currentEventData = {
						x: currentEvent.x,
						title: isEPS? close :  actual,
						text: `<span class="tooltipDate">${currentEventDate}</span><br><span class="tooltipText" style="color: ${flagColour};">${country} ${currentEventText}</span><br><span>Actual: </span><span class="tooltipActual" style="color: ${flagColour};">${actual}</span><br><span>Forecast: </span><span class="tooltipForecast" style="color: ${flagColour};">${forecast != 'null'? forecast : 'n/a'}</span>`,	
					}
					if (isEPS) {
						currentEventData.text = `<span class="tooltipDate">FY ${refDate}</span><br><span class="tooltipText" style="color: ${flagColour};">${name}</span><br><span>Actual: </span><span class="tooltipActual" style="color: ${flagColour};">${close}</span><br>`
					}
					options.data.push(currentEventData)

				})

				document.querySelector(".highcharts-root").style.visibility = "hidden"
				document.querySelector(".mkspinner").style.display = "block"
				//Remove SMA
				const smaIndexesArr = []
				_th.chart.series.forEach((item, index) => {
					if (item.userOptions.type == 'sma') {
						smaIndexesArr.push(index)
					}
				}) 
				smaIndexesArr.sort((a, b) => b - a)
				for (let i = 0; i < smaIndexesArr.length ; i++) {
					_th.chart.series[smaIndexesArr[i]].remove()
				}
				smaCount = 0
				$("#smaLabels").remove();
				indicatorsInUse = indicatorsInUse.filter((item) => item.type != 'sma')
				$("#diffLabels").remove()
				differenceSeries = false
				chartTitle(_th.chart.series)
				_th.chart.addSeries(options)
				const chartTypeButtons = Array.from(document.getElementById("iChart-dpMenu-cnt-type").children)
				const currentChartTypeButtonIndex = chartTypeButtons.findIndex((item) => item.dataset.type == _th.chart.prevType)
				console.log('index: ' + currentChartTypeButtonIndex);

					noDuplAnnotAfterFlags = true
					_th.update('type', currentChartType);

					document.querySelector(".highcharts-root").style.visibility = "visible"
					document.querySelector(".mkspinner").style.display = "none"

				$(".highcharts-series-group").insertAfter($( ".crosshair-fix-vertical" ));
				if (!$("#flagLabels")[0]){
					($('<div id="flagLabels"></div>')).insertAfter("#iChart-bodyLabels-cntx")
				}
				const flagLabel = $(`<span id="${options.id}_label_span" class="flagLabel" style="${isDarkMode? 'border: 1px solid ' +  shadeColor2(flagColour, 0.7) : 'background-color: ' + shadeColor2(flagColour, 0.7) + ';' + 'border: 1px solid ' +  shadeColor2(flagColour, 0.7)};"></span>`)
				flagLabel.append($(`<span class="flagLabelDesc" id="${options.id}_label" style="color:${flagColour};">${options.isEPS? options.name : options.country + ', ' + options.category}</span>`))
				flagLabel.append($(`<span class="flagVisibility" id="${options.id}_label_vis_icon">${SVG_ICONS['visible'].replace('fill="black"', `fill="${flagColour}"`)}</span>`).click(function(){	
					const flagSeriesIndex = findSeriesIndex(_th.chart.series, options.id)
					if (_th.chart.series[flagSeriesIndex].visible) {
						document.getElementById(`${options.id}_label_vis_icon`).innerHTML = SVG_ICONS['invisible'];
						document.getElementById(`${options.id}_label_span`).classList.add('flagLabelHidden')
					} else {
						document.getElementById(`${options.id}_label_vis_icon`).innerHTML = SVG_ICONS['visible'].replace('fill="black"', `fill="${flagColour}"`);
						document.getElementById(`${options.id}_label_span`).classList.remove('flagLabelHidden')
					}
					_th.chart.series[flagSeriesIndex].update({visible: !_th.chart.series[flagSeriesIndex].visible})
				}))
				flagLabel.append($(`<span class="removeEvent" id="${options.id}_event_remove_icon">${SVG_ICONS['cross']}</span>`).click(function(){
					const flagSeriesIndex = findSeriesIndex(_th.chart.series, options.id)
					_th.chart.series[flagSeriesIndex].remove()
					flagSeriesArr.splice(flagSeriesArr.indexOf(options.symbol), 1)
					flagsColourArr.push(flagColour)
					flagCount--;
					flagLabel.remove()
					chartTitle(_th.chart.series)
					if (flagCount < 4) {
						$('#eventsBtn').removeClass('disabled');
						$('#dark-eventsBtn').removeClass('disabled');
						$('#eventsMenuOption').removeClass('disabled');
					}
				}))

				$("#flagLabels").append(flagLabel)
				document.getElementById(`${options.id}_label_vis_icon`)
				if (flagCount >= 4) {
					$('#eventsBtn').addClass('disabled');
	  				$('#dark-eventsBtn').addClass('disabled');
					$('#eventsMenuOption').addClass('disabled');
				}
				plotEvents = false;
				return
			}
			$("#downloadBtn").show()
			$("#dark-downloadBtn").show()
			$('#dark-superMenuBtn').show()
			$('#superMenuBtn').show()
			$('.compareBtn').removeClass('compareBtnActive')
			console.log('ADDING NEW SERIES-----------------------------------------');

			for (var i in saveUserSelections) {
				delete saveUserSelections[i].color;
			}

			if(!cdata.secondSymbol) {
				cdata.secondSymbol = val;
				secondaryAxisMargin = true;
			}
			else if(!cdata.thirdSymbol) {
				cdata.thirdSymbol = val;
			}
			else if(!cdata.fourthSymbol) {
				cdata.fourthSymbol = val;
			}
			else if(!cdata.fifthSymbol) {
				cdata.fifthSymbol = val;
			}

			btn.removeClass("iChart-headerSearch-clean");
			input.hide();
			icon.show();

			$(".iChart-plotLabel").hide(); 
			$('.closeLine').hide();

			$(".iChart-menu2-bottom-left-horizontal").show()
			$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","-17px")
			_th.compareSeries ? _th.compareSeries++ : _th.compareSeries = 1;
			cdata.compareNumber = cdata.compareNumber + 1;
			if (_th.config.cdata.compareNumber > 1) {
				$(".iChart-menu2-bottom-cnt-horizontal").addClass("compare")
			} else {
				$(".iChart-menu2-bottom-cnt-horizontal").removeClass("compare")
			}
			if(log) { console.log("mkchart -> cdata.compareNumber", cdata.compareNumber); }
			_this.events.search(val, true);
		},
		onFocus: function onFocus() {
			var pos = _this.calcDropDownPos(btn, dp);
			pos.top = 40;
			dp.css(pos);
		},
		events: {
			documentClick: function documentClick(taCnt, taInput) {
				if (!inputIsHover) {
					btn.removeClass("iChart-headerSearch-clean");
					taCnt.hide();
					input.hide();
					icon.show();
					plotEvents = false;
				}
			}
		},
		theme: _this.theme
	});

	if (refCb) refCb(btn);
};

function buildChartMenu_fullscreen() {
	var menu = this,
	    cnt = div({
		float: 'right',
		'line-height':'2.5'
	}, {
		'class': 'iChart-header-option iChartHeader-button header-buttons fullScreenBtn'
	});

	cnt.append(SVG_ICONS['expand'] || '<span>Fullscreen</span>');

	addShareWrapper.call(this);
	cnt.on('click', function (e) {
		e.preventDefault();
		var isFullScreen = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen;
		menu.events.fullscreenClick(isFullScreen);
	});

	var fsChangeFunc = function fsChangeFunc(e) {
		var isFullScreen = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen;
		menu.events.fullscreenChange(isFullScreen);
	};

	document.addEventListener("webkitfullscreenchange", fsChangeFunc, {passive: true});
	document.addEventListener("mozfullscreenchange", fsChangeFunc, {passive: true});
	document.addEventListener("MSFullscreenChange", fsChangeFunc, {passive: true});

	menu.cnt.append(cnt);
};

function buildBottomSettings() {
	//COG WHEEL FOR MAIN Y AXIS
	var _this = this,
	cnt = div({}, { 'id':'iChart-bottom-right-horizontal', 'class': 'iChart-menu2-bottom-right-horizontal cogPush' }).appendTo(_this.cnt.footer);
	buildChartOutSettings.call(_this, cnt, "y_axis_main");

	if(indicatorsFlag == true){
		buildChartOutSettings.call(_this, cnt, "formula");
	}

	//COG WHEEL FOR SECUNDARY Y AXIS WILL BE DISPLAY NONE WHEN LOADING
	cnt = div({'display':'none'}, {  'id':'iChart-bottom-left-horizontal', 'class': 'iChart-menu2-bottom-left-horizontal' }).prependTo(_this.cnt.footer);
	buildChartOutSettings.call(_this, cnt, "y_axis_2");
};

function generateUniqueID(){
	return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
}

function removeIndicator(where, idToBeRemoved) {
  if (where == "indicator") {
    var updateIndicatorsFrom = 0,
      startUpdateIndicators = false;

    //remove from chart object and updates the series on global indicators object
    for (let i = 0; i <= indicatorsInUse.length - 1; i++) {
      if (idToBeRemoved == indicatorsInUse[i].id) {			
        for (let rem of indicatorsInUse[i].serieIndex) {
          if (updateIndicatorsFrom < rem) updateIndicatorsFrom = rem;
          _th.chart.series[rem - 1].remove();
        }
        startUpdateIndicators = true;
      }
      if (
        Math.max(...indicatorsInUse[i].serieIndex) > updateIndicatorsFrom &&
        startUpdateIndicators
      ) {
        indicatorsInUse[i].serieIndex = indicatorsInUse[i].serieIndex.map(
          function (v) {
            return v - 2;
          }
        );
      }
    }

    //remove from global object
    indicatorsInUse = indicatorsInUse.filter(function (value, index, arr) {
      return value.id != idToBeRemoved;
    });

    //remove from menu indicator list
    $("#wrapper-" + idToBeRemoved).remove();
    _th.chart.redraw();
  } else if (where == "annotation") {
		for(let ind in _th.chart.annotations){
			if(_th.chart.annotations[ind].clipRect.id === idToBeRemoved){
				_th.chart.removeAnnotation(_th.chart.annotations[ind])
				//_th.chart.options.annotations.splice(ind, 1);
				//if(_th.chart.annotations[ind].userOptions){
					//if (_th.chart.annotations[ind].userOptions.langKey == 'label') {
						_th.chart.options.annotations.splice(ind, 1);
					//}
				//}
				
				//$("#wrapper-annotation-" + ind).remove();
				_th.chart.navigationBindings.deselectAnnotation();
    			_th.chart.redraw();
			}
		}
  }
}

const editAnnotation = (chart, annotation) => {
	Highcharts.fireEvent(
		chart.navigationBindings,
		'showPopup', {
			options: chart.navigationBindings.annotationToFields(annotation),
			formType: 'annotation-edit',
			onSubmit:
				function(data) {
					let config = {}

					if (data.actionType === 'remove') {
						chart.navigationBindings.activeAnnotation = false;
						chart.navigationBindings.chart.removeAnnotation(annotation);
					} else {
						chart.navigationBindings.fieldsToOptions(
							data.fields,
							config
						);
						chart.navigationBindings.deselectAnnotation();

						if (annotation.options.type === 'measure') {
							config.typeOptions.crosshairY.enabled = (
								config.typeOptions.crosshairY
								.strokeWidth !== 0
							);
							config.typeOptions.crosshairX.enabled = (
								config.typeOptions.crosshairX
								.strokeWidth !== 0
							);
						}
						annotation.update(config);
					}
				}
		}
	)
}

function editIndicator(idToBeEdit) {
  for (let i = 0; i <= indicatorsInUse.length - 1; i++) {
    if (idToBeEdit == indicatorsInUse[i].id) {
			indicatorChoosen = indicatorsInUse[i].name.split(" ")[0].toLowerCase()
			$(".indicatorModalTitle").html("Edit "+indicatorsInUse[i].name+" </br>");
      $("#inputIndicatorModal").val(indicatorsInUse[i].period);
      var colorArraysInd = ["#FF6633","#FF33FF","#FFFF99","#00B3E6","#99FF99","#E6331A","#66994D", "#9900B3","#99E6E6"];

      for (let color of colorArraysInd) {
        $("#color-" + color.replace("#", "")).removeClass("color-square-active");
      }
			$("#color-" + indicatorsInUse[i].color.replace("#", "")).addClass("color-square-active");
    }
  }
  $(".iChart-indicators-modal").show();
}

function buildIndicatorsInUseMenu() {
  var formulaMenu = $(".optionsY-formula");
	$(".wrapper-annotation").remove();
  if (indicatorsInUse.length > 0) {
    for (let ind of indicatorsInUse) {
      if (ind.toUpdate == true) {
        var indicatorT = $(
          '<div id="wrapper-' + ind.id + '" class="wrapper-indicator"></div>'
        );

        var indicatorC = $(
          '<span style="cursor:default; width:20px; height:5px; background-color: ' +
            ind.color +
            '"></span>'
        );
        var indicatorS = $(
          '<span class="ind-' + ind.id + '">' + ind.name + "</span>"
        );
        var indicatorE = $(
          '<button id="edit-ind-' +
            ind.id +
            '" class="pencil-svg-indicators">' +
            SVG_ICONS["pencil"] +
            "</button>"
        ).click(function (e) {
          e.preventDefault();
          editIndicator(ind.id);
        });
        var indicatorD = $(
          '<button id="delete-ind-' +
            ind.id +
            '" class="delete-indicators"> X </button>'
        ).click(function (e) {
          e.preventDefault();
          removeIndicator('indicator',ind.id);
        });

				if(isDarkMode==true){
					$(indicatorS).css("color","rgb(211,211,211)")
					$(indicatorD).css("color","rgb(211,211,211)")
				}
        indicatorT.append(indicatorC, indicatorS, indicatorE, indicatorD);
        formulaMenu.prepend(indicatorT);
        ind.toUpdate = false;
      }
    }
  }

	 //FOR ANNOTATIONS THE BEHAVIOUR IS DIFFERENT
  if (_th.chart.annotations.length > 0) {
    for (const index of _th.chart.annotations.keys()) {
      var colorAnnotation = _th.chart.annotations[index].options.shapeOptions["stroke"]
			if(_th.chart.annotations[index].userOptions.typeOptions.line != undefined){
				colorAnnotation = _th.chart.annotations[index].userOptions.typeOptions.line["stroke"]
			}
			var annotationT = $(
				'<div id="wrapper-annotation-' + index + '" class="wrapper-annotation"></div>'
			);

			var annotationC = $(
				'<span style="cursor:default; width:20px; height:5px; background-color: ' +
				colorAnnotation +
					'"></span>'
			);
			var annotationS = $(
				'<span class="annotation-' + index + '">TLine - ' + index + '</span>'
			);
			var annotationE = $(
				'<button id="edit-annotation-' +
					index +
					'" class="pencil-svg-indicators">' +
					SVG_ICONS["pencil"] +
					"</button>"
			).click(function (e) {
				e.preventDefault();
				editAnnotation(_th.chart, _th.chart.annotations[index])
			});
			var annotationD = $(
				'<button id="delete-annotation-' +
					index +
					'" class="delete-indicators"> X </button>'
			).click(function (e) {
				e.preventDefault();
				
				removeIndicator('annotation', index);
			});

			if(isDarkMode==true){
				$(annotationS).css("color","rgb(211,211,211)")
				$(annotationD).css("color","rgb(211,211,211)")
			}

			annotationT.append(annotationC, annotationS, annotationE, annotationD);
			formulaMenu.prepend(annotationT);
    }
  }
}

function buildChartOutSettings(parentCnt, divRef) {
  if (!this.config.menu.outSettings) {
    return;
  }

  var _this = this,
    cnt = parentCnt;
  
	if(divRef != 'formula'){

	
		var cogWheelYMainDiv = div({},
			{
				'id': "cogWheel-" + divRef ,
				'class': isDarkMode == true ? 'darkButton-'+divRef : ''
			});

	cogWheelYMainDiv.append($(`${SVG_ICONS[/*"cogWheel"*/'cogwheel_2']}`));


  cogWheelYMainDiv.click(function (e) {
    e.preventDefault();
	
    if (!$(".optionsY-" + divRef)[0]) {
      if (divRef == "y_axis_main") {
        $(".optionsY-y_axis_2").hide();
      } else if (divRef == "y_axis_2") {
        $(".optionsY-y_axis_main").hide();
      }

      var settingsArray = [
        "Invert Scale",
        "hr",
        "Percentage",
        "Numeric",
        "Difference",
      ];

      var select = Highcharts.createElement(
        "div",
        {
          className: "optionsY-" + divRef,
        },
        {},
        document.getElementById("cogWheel-" + divRef)
      );

			isDarkMode == true ? $(".optionsY-" + divRef).addClass('darkSubMenu') : $(".optionsY-" + divRef).removeClass('darkSubMenu'),

      settingsArray.forEach(function (elem, idx, array) {
        if (elem == "hr") {
          var newOption = Highcharts.createElement("hr", {}, {}, select);
        } else {
          var newOption = Highcharts.createElement("a", {
            className:
              idx === 0
                ? `opt-${elem
                    .split(" ")
                    .join("-")
                    .toLowerCase()}-${divRef} opt-firstItem`
                : "opt-" +
                  elem.split(" ").join("-").toLowerCase() +
                  "-" +
                  divRef,
            innerHTML: elem,
            //'href': '#',
          });

          $(".opt-numeric-" + divRef).addClass("optionActivated");
          newOption.addEventListener("click", function (e) {
            e.preventDefault();
						saveAnnotationsAutomatically(true)
            switch (newOption.innerHTML.toLowerCase()) {
              case "percentage":
				_this.update("axisType", "percent-" + divRef);
                break;
              case "numeric":
                _this.update("axisType", "auto-" + divRef);
                break;
              case "difference":
                _this.update("axisType", "value-" + divRef);
                break;
              case "invert scale":
                _this.update("invert", divRef);
                break;
              default:
                break;
            }
          });
        }
				if(isFS){
					$(".optionsY-" + divRef).css("margin-bottom","32px" )
				 }else{
					$(".optionsY-" + divRef).css("margin-bottom","0px" )
				 }
        select.append(newOption);
      });
	  let isPercentage = false
	  if (divRef == 'y_axis_main' && _this.chart.yAxis[0].series.length < 3) {
		isPercentage = checkIfPercentage(_this.chart.yAxis[0].series[0].options.full_name)
	  } else if (divRef == 'y_axis_2' && _this.chart.yAxis[2].series.length < 2) {
		isPercentage = checkIfPercentage(_this.chart.yAxis[2].series[0].options.full_name)
	  }
	  if (isPercentage) {
		$(".opt-percentage-" + divRef).css('display', 'none')
	  }  else {
		$(".opt-percentage-" + divRef).css('display', 'initial')
	  }
    } else {
      if (!$(".optionsY-" + divRef).is(":visible")) {
        $(".opt-percentage-" + divRef).removeClass("optionActivated");
        $(".opt-numeric-" + divRef).removeClass("optionActivated");
        $(".opt-difference-" + divRef).removeClass("optionActivated");
        $(".opt-invert-scale-" + divRef).removeClass("optionActivated");

        for (let indAxis in _this.chart.yAxis) {
          if (_this.chart.yAxis[indAxis].userOptions.id == divRef) {
            var axis = indAxis;
          }
        }
        var objLocation = "";

        if (divRef == "y_axis_main") {
          objLocation = _this.config.cdata.chartType;
          $(".optionsY-y_axis_2").hide();
        } else if (divRef == "y_axis_2") {
          objLocation = _this.config.cdata.chartType2;
          $(".optionsY-y_axis_main").hide();
        } else {
          objLocation = _this.config.cdata.chartTypeN;
        }

        if (objLocation == "auto" || objLocation == undefined) {
          $(".opt-numeric-" + divRef).addClass("optionActivated");
        } else if (objLocation == "percent") {
          $(".opt-percentage-" + divRef).addClass("optionActivated");
        } else if (objLocation == "value")
          $(".opt-difference-" + divRef).addClass("optionActivated");

        if (_this.chart.yAxis[axis].reversed) {
          $(".opt-invert-scale-" + divRef).addClass("optionActivated");
        } else {
          $(".opt-invert-scale-" + divRef).removeClass("optionActivated");
        }
				if(isFS){
					$(".optionsY-" + divRef).css("margin-bottom","32px" )
				 }else{
					$(".optionsY-" + divRef).css("margin-bottom","0px" )
				 }
        $(".optionsY-" + divRef).show();
      } else {
        $(".optionsY-" + divRef).hide();
      }
	  let isPercentage = false
	  if (divRef == 'y_axis_main' && _this.chart.yAxis[0].series.length < 3) {
		isPercentage = checkIfPercentage(_this.chart.yAxis[0].series[0].options.full_name)
	  } else if (divRef == 'y_axis_2' && _this.chart.yAxis[2].series.length < 2) {
		isPercentage = checkIfPercentage(_this.chart.yAxis[2].series[0].options.full_name)
	  }
	  if (isPercentage) {
		$(".opt-percentage-" + divRef).css('display', 'none')
	  } else {
		$(".opt-percentage-" + divRef).css('display', 'initial')
	  }
    }
  });

	$(document).on('click', function (e) {
		var cogContainer = $(".optionsY-y_axis_main");
		var cogContainerBtn = $("#cogWheel-y_axis_main")
			if (!cogContainerBtn.is(e.target) && cogContainerBtn.has(e.target).length === 0) 
    	{
        cogContainer.hide();
    	}

		var cogContainer = $(".optionsY-y_axis_2");
		var cogContainerBtn = $("#cogWheel-y_axis_2")
			if (!cogContainerBtn.is(e.target) && cogContainerBtn.has(e.target).length === 0) 
				{
					cogContainer.hide();
				}
	});

  //cnt.append(p).append(l).append(d).append(i).append(cogWheelYMainDiv);
  cnt.append(cogWheelYMainDiv);

  _this.menu.options.outSettings = {
    options: [cogWheelYMainDiv],
    update: function update() {},
  };
}
if (divRef == "formula") {
  var formulaDiv = div(
    {},
    {
      id: isDarkMode == true ? "darkButton-icharts-formula":"icharts-formula",
      class: "",
    }
  );

  formulaDiv.append($(`${SVG_ICONS["formula"]}`));
  /**************************************************************************** */

  formulaDiv.click(function (e) {
    e.preventDefault();

    if (!$(".iChart-indicators-modal")[0]) {
      buildIndicatorsModal();
    }

    if (!$(".optionsY-" + divRef)[0]) {
      var settingsArray = [
        "Select Indicator",       
        "Simple Moving Average",
        "Trending Line",
      ];

			if(isDarkMode==false){
				settingsArray.splice(1, 0, "hr");
			}

      var select = Highcharts.createElement(
        "div",
        {
          className: isDarkMode == true ? `optionsY-${divRef} darkSubMenu`: "optionsY-" + divRef,
        },
        {},
        document.getElementById(isDarkMode==true? "darkButton-icharts-formula":"icharts-formula")
      );

      settingsArray.forEach(function (elem, idx, array) {
        if (elem == "hr") {
          var newOption = Highcharts.createElement("hr", {}, {}, select);
					if(isDarkMode==true){
						$(newOption).css("color","rgb(211,211,211) !important")
					}
        } else if (elem == "Select Indicator") {
          var newOption = Highcharts.createElement(
            "h6",
            { className: isDarkMode==true? "dark-formulaTitleMenu":"formulaTitleMenu", innerHTML: elem },
            {},
            select
          );
        } else {
          var newOption = Highcharts.createElement("a", {
            className:
              idx === 0
                ? `opt-${elem
                    .split(" ")
                    .join("-")
                    .toLowerCase()}-${divRef} opt-firstItem`
                : "opt-" +
                  elem.split(" ").join("-").toLowerCase() +
                  "-" +
                  divRef,
            innerHTML: elem,
            //'href': '#',
          });

          $(".opt-numeric-" + divRef).addClass("optionActivated");
          newOption.addEventListener("click", function (e) {
            e.preventDefault();
            switch (newOption.innerHTML.toLowerCase()) {
              case "simple moving average": {
                indicatorChoosen = "sma";
                $(".indicatorModalTitle").html("Simple Moving Average </br>");
                $(".iChart-indicators-modal").show();
                break;
              }
              case "trending line":
                var a = $(".highcharts-segment");
                a.click();
                break;
              default:
                break;
            }
          });
        }
        if (isFS) {
          $(".optionsY-" + divRef).css("margin-bottom", "32px");
        } else {
          $(".optionsY-" + divRef).css("margin-bottom", "0px");
        }
        select.append(newOption);
      });
    } else {

      if (!$(".optionsY-" + divRef).is(":visible")) {
        if (indicatorsInUse.length > 0 || _th.chart.annotations.length > 0) {
          buildIndicatorsInUseMenu();
        }
        if (isFS) {
          $(".optionsY-" + divRef).css("margin-bottom", "32px");
        } else {
          $(".optionsY-" + divRef).css("margin-bottom", "0px");
        }
        $(".optionsY-" + divRef).show();
      } else {
        $(".optionsY-" + divRef).hide();
      }
    }
  });

  //cnt.append(p).append(l).append(d).append(i).append(cogWheelYMainDiv);

  $(document).on("click", function (e) {
    var targetEle = $(e.target);
    if (
      !targetEle[0].id == "icharts-formula" || !targetEle[0].id == "darkButton-icharts-formula" ||
      !targetEle[0].outerHTML.includes("M15.6,5.29C14.5,5") ||
      targetEle[0].className == "iChart-wrapper-footer" ||
      targetEle[0].localName == "body"
    ) {
      $(".optionsY-formula").hide();
    }
  });

	//cnt.append(formulaDiv);

  _this.menu.options.outSettings = {
    options: [cogWheelYMainDiv],
    update: function update() {},
  };
}

parentCnt.append(cnt);
};

function update_ChartOutSettings() {

	if (!this.menu.options.outSettings) {
		return;
	}
	var _this = this,
	    options = _this.menu.options.outSettings.options || [],
	    currentType = _this.config.cdata.chartType;
		currentType == 'auto' ? currentType = 'undefined' : ''

	for (var i = 0; i < options.length; i++) {
		if(isDarkMode == true){
			//options[i].addClass('dark-iChart-active')
		}else{
			options[i].addClass('iChart-active');
		}

		if (options[0].attr('data-axis') == currentType) {
			if(isDarkMode == true){
				//breaking with active class
				//options[0].addClass('dark-iChart-active')
			}else{
				options[0].addClass('iChart-active');
			}
		}
	}
};

function saveAnnotationsAutomatically(clean){
	_th.chart.navigationBindings.deselectAnnotation();
	annotationsInUse = {}
	for(let annot in _th.chart.annotations){
		//handle text annotations
		if (_th.chart.annotations[annot].userOptions.langKey.toLowerCase() == 'label') {
			annotationsInUse[annot] = {
				"langKey":  _th.chart.annotations[annot].userOptions.langKey,
				"type": _th.chart.annotations[annot].userOptions.type,
				"labels": _th.chart.annotations[annot].userOptions.labels,
			}
			continue
		}
		annotationsInUse[annot] = {
			"point0": _th.chart.annotations[annot].userOptions.typeOptions.points[0], 
			"point1": _th.chart.annotations[annot].userOptions.typeOptions.points[1],
			"shapeOptions":  _th.chart.annotations[annot].userOptions.shapeOptions,
			"line" :	_th.chart.annotations[annot].userOptions.typeOptions.line ? _th.chart.annotations[annot].userOptions.typeOptions.line : null
		}
	}
	resetAnnotations(clean)
}

function buildIndicator(colorChoosen) {
	if (indicatorChoosen != undefined) {
	  if (indicatorChoosen == "sma") {
		  const sma_id = generateUniqueID()
			  const options = {
		  type: indicatorChoosen,
		  linkedTo: _th.series[Object.keys(_th.series)[0]].config.id,
		  yAxis: 0,
				  color:colorChoosen,
		  params: {
			period: globalPeriod,
		  },
		  id: sma_id + '_1',
		}
		//Remove flags
			const flagIndexesArr = []
		  _th.chart.series.forEach((item, index) => {
			  if (item.userOptions.type == 'flags') {
				  flagIndexesArr.push(index)
			  }
		  })
		  flagIndexesArr.sort((a, b) => b - a)
		  for (let i = 0; i < flagIndexesArr.length ; i++) {
			  _th.chart.series[flagIndexesArr[i]].remove()
		  }
			flagCount = 0
		  flagSeriesArr = []
		  $('#eventsBtn').removeClass('disabled');
			$('#dark-eventsBtn').removeClass('disabled');
		  $("#flagLabels").remove();
		  if (isDarkMode) {
			  flagsColourArr = ['#0585e9', '#fa7a16', '#e082e0', '#eea809']
		  } else {
			  
			  flagsColourArr = ['#067f9a', '#fa7a16', '#631f7d', '#eea809']
		  }
  
			_th.chart.addSeries(options);
			options.id = sma_id + '_2'
		  _th.chart.addSeries(options);
		  smaCount++
		  chartTitle(_th.chart.series)
		  //Labels
		  if (!$("#smaLabels")[0]){
			  ($('<div id="smaLabels"></div>')).insertAfter("#iChart-bodyLabels-cntx")
		  }
		  const smaLabel = $(`<span id="${sma_id}_label_span" class="smaLabel"></span>`)
		  smaLabel.append($(`<span class="smaLabelColour" id="${sma_id}_colour" style="background-color:${colorChoosen};"></span>`))
		  smaLabel.append($(`<span class="smaLabelDesc" id="${sma_id}_label" style="color:${colorChoosen};">SMA (${options.params.period})</span>`))
		  smaLabel.append($(`<span class="removeSMA" id="${sma_id}_remove_icon">${SVG_ICONS['cross']}</span>`).click(function(){
			  const smaSeriesIndex_1 = findSeriesIndex(_th.chart.series, sma_id + '_1')
			  _th.chart.series[smaSeriesIndex_1].remove()
			  const smaSeriesIndex_2 = findSeriesIndex(_th.chart.series, sma_id + '_2')
			  _th.chart.series[smaSeriesIndex_2].remove()
			  indicatorsInUse = indicatorsInUse.filter(el => el.id != sma_id);
			  smaLabel.remove()
			  smaCount--
			  chartTitle(_th.chart.series)
			  // chartTitle(_th.chart.series)
			  // if (smaCount < 4) {
			  // 	$('#eventsBtn').removeClass('disabled');
			  // 	$('#dark-eventsBtn').removeClass('disabled');
			  // }
		  }))
  
		  $("#smaLabels").append(smaLabel)
		  // if (smaCount >= 4) {
		  // 	$('#eventsBtn').addClass('disabled');
		  // 	  $('#dark-eventsBtn').addClass('disabled');
		  // }
		  indicatorsInUse.push({type: "sma", id: sma_id, name: _th.chart.series[_th.chart.series.length - 1].name , period: globalPeriod,color: _th.chart.series[_th.chart.series.length - 1].color, serieIndex:[_th.chart.series.length,  _th.chart.series.length-1] ,toUpdate:true})
	  }
	}

  indicatorChoosen = undefined;
  globalPeriod = 14;

}

function cloneAnnotation(annotationClicked){
	let date_1 = new Date(annotationClicked.points[0].x);
	let date_2 = new Date(annotationClicked.points[1].x);
	let difference = date_1- date_2;
	let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
	let TotalMinutes = Math.ceil(difference / (60 *1000));
	var valXDeviate = 0
	var valYDeviate = 0
	var invertXDirection = false
	var invertYDirection = false

	const yPosition = (_th) =>{
		return _th.chart.yAxis[0].paddedTicks[1] - _th.chart.yAxis[0].paddedTicks[0]
	}

	if((annotationClicked.points[0].x > _th.chart.xAxis[0].paddedTicks[_th.chart.xAxis[0].paddedTicks.length-3]) && (annotationClicked.points[1].x > _th.chart.xAxis[0].paddedTicks[_th.chart.xAxis[0].paddedTicks.length-3])){
		invertXDirection = true
	}
	if((annotationClicked.points[0].y < _th.chart.yAxis[0].paddedTicks[3]) && (annotationClicked.points[1].y < _th.chart.yAxis[0].paddedTicks[3])){
		invertYDirection = true
	}

	if (thisInterval.charAt(thisInterval.length - 1) === "d") {
		if (TotalDays < 60 && TotalDays >= -60) {
			valXDeviate = 1656691003;
		} else {
			valYDeviate = yPosition(_th)
		}
	} else if (thisInterval.charAt(thisInterval.length - 1) === "m") {
		if (thisInterval === "1m") {
			if (TotalMinutes < 60 && TotalMinutes >= -60) {
				valXDeviate = 600000;
			} else {
				valYDeviate = yPosition(_th)
			}
		} else if (thisInterval === "5m") {
			if (TotalMinutes < 240 && TotalMinutes >= -240) {
				valXDeviate = 600000 * 4;
			} else {
				valYDeviate = yPosition(_th)
			}
		} else if (thisInterval === "15m") {
			if (TotalMinutes < 1120 && TotalMinutes >= -1120) {
				valXDeviate = 6000000 * 2;
			} else {
				valYDeviate = yPosition(_th)
			}
		}
	} else if (thisInterval === "1h") {
		if (TotalMinutes < 8500 && TotalMinutes >= -8500) {
			valXDeviate = 60000000 * 2;
		} else {
			valYDeviate = yPosition(_th)
		}
	}else if (thisInterval === '1w'){
		if (TotalDays < 225 && TotalDays >= -225) {
			valXDeviate = (1656691003*5);
		} else {
			valYDeviate = yPosition(_th)
		}
	}else if (thisInterval === '1month'){
		if (TotalDays < 1165 && TotalDays >= -1165) {
			valXDeviate = (1656691003*10);
		} else {
			valYDeviate = yPosition(_th)
		}
	}

	var newAnnotation = {
		langKey: 'Trending Line (Clone)',
		type: 'crookedLine',
		typeOptions: {
		points: [{
			x: invertXDirection == false ? (annotationClicked.points[0].x + valXDeviate) : (annotationClicked.points[0].x - valXDeviate),
			y: invertYDirection == false ? (annotationClicked.points[0].y - valYDeviate) : (annotationClicked.points[0].y + valYDeviate),
			xAxis: 0,
			yAxis: 0
		}, {
			x: invertXDirection == false ? (annotationClicked.points[1].x + valXDeviate) : (annotationClicked.points[1].x - valXDeviate),
			y: invertYDirection == false ? (annotationClicked.points[1].y - valYDeviate) : (annotationClicked.points[1].y + valYDeviate ),
			xAxis: 0,
			yAxis: 0
		}]
	},
	shapeOptions: {
		stroke: 'red',
		strokeWidth: 2
	},
	events:{
		contextmenu: function(e) {
		e.preventDefault();
		e.stopPropagation();
		// buildContextMenu(e.clientX,e.clientY, this)
		addContextMenuWithDots('line', this)
		return false;
	}
	}
}
_th.chart.addAnnotation(newAnnotation, true)
}

function HVlineAnnotation(posY, posX, lineType){
	var newAnnotation = {
		langKey: 'Trending Line (Clone)',
		type: 'crookedLine',
		class: lineType,
		typeOptions: {
		points: [{
			x: lineType === 'horizontalLine' ? posX.max * 10 : posX,
			y: lineType === 'horizontalLine' ? posY : posY.max * 10,
			xAxis: 0,
			yAxis: 0
		}, {
			x: lineType === 'horizontalLine' ? posX.min / 10 : posX,
			y: lineType === 'horizontalLine' ? posY : posY.max / 10,
			xAxis: 0,
			yAxis: 0
		}]
	},
	shapeOptions: {
		stroke: 'red',
		strokeWidth: 2
	},
	events:{
		contextmenu: function(e) {
		e.preventDefault();
		e.stopPropagation();
		// buildContextMenu(e.clientX,e.clientY, this)
		addContextMenuWithDots('line', this)
		return false;
	}
	}
}
_th.chart.addAnnotation(newAnnotation, true)
$('.highcharts-annotation:last').addClass(lineType)
}

function resetAnnotations(clean){
	_th.chart.navigationBindings.deselectAnnotation();
	const annotations = _th.chart.annotations
  for (let i = annotations.length - 1; i > -1; --i) {
    _th.chart.removeAnnotation(annotations[i])
  }
	_th.chart.options.annotations = []
	if(clean === true){
		annotationsInUse ={}
	}
}

function recreateAnnotation() {
  for (let index in annotationsInUse) {
	//handle text annotations
	if (annotationsInUse[index].langKey) {
		if (annotationsInUse[index].langKey.toLowerCase() == 'label') {
			let newTextAnnotation = {
				langKey: annotationsInUse[index].langKey,
				type: annotationsInUse[index].type,
				labels: annotationsInUse[index].labels,
				events: {
					contextmenu: function (e) {
					  e.preventDefault();
					  e.stopPropagation();
					//   buildContextMenu(e.clientX, e.clientY, this);
					addContextMenuWithDots('label', this)
					  return false;
					},
					dblclick: function(e) {
						e.preventDefault();
						if (this.userOptions) {
							if (this.userOptions.langKey) {
								if (this.userOptions.langKey.toLowerCase() == 'label') {
									addTextAnnotationPopup(this)
								}
							}
						}
					}
				},
			}
			_th.chart.addAnnotation(newTextAnnotation, true)
			continue
		}
	}

    var newAnnotation = {
      langKey: "Trending Line",
      type: "crookedLine",
      typeOptions: {
        points: [
          {
            x: annotationsInUse[index].point0.x,
            y: annotationsInUse[index].point0.y,
            xAxis: 0,
            yAxis: 0,
          },
          {
            x: annotationsInUse[index].point1.x,
            y: annotationsInUse[index].point1.y,
            xAxis: 0,
            yAxis: 0,
          },
        ],
      },
      shapeOptions: {
        stroke: annotationsInUse[index].line !== null ? (annotationsInUse[index].line.hasOwnProperty('stroke') ? annotationsInUse[index].line.stroke : annotationsInUse[index].shapeOptions.stroke) : annotationsInUse[index].shapeOptions.stroke,
        strokeWidth: annotationsInUse[index].line !== null ? (annotationsInUse[index].line.hasOwnProperty('strokeWidth') ? annotationsInUse[index].line.strokeWidth : annotationsInUse[index].shapeOptions.strokeWidth) : annotationsInUse[index].shapeOptions.strokeWidth ,
      },
      events: {
        contextmenu: function (e) {
          e.preventDefault();
		  e.stopPropagation();
        //   buildContextMenu(e.clientX, e.clientY, this);
		addContextMenuWithDots('line', this)
          return false;
        },
      },
    };
    _th.chart.addAnnotation(newAnnotation, true);
  }
}

function buildContextMenu(x, y,annotationClicked){
	annotationClicked.graphic.element.hcEvents.click[0].fn(annotationClicked);
	$('#contextMenu').remove()
	$('#dark-contextMenu').remove()
	$('.iChart-indicators-modal').remove()
	if(!$('#contextMenu')[0] || !$('#dark-contextMenu')[0]){
		var contextMenuDiv = div({ top: y+'px', left: x+'px'}, { 'id': isDarkMode == true ? 'dark-contextMenu' : 'contextMenu' });
		var option1 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Clone (insert)">${SVG_ICONS['clone']} Clone</span><span class="shortcut">Insert</span>`)).click((e)=>{
			e.preventDefault()
			cloneAnnotation(annotationClicked)
			$('#contextMenu').remove()
			$('#dark-contextMenu').remove()
			$(".iChart-indicators-modal").remove()
		})
		var option2 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Delete (del)">${SVG_ICONS[/*'trash'*/'delete']} Remove</span><span class="shortcut">Del</span>`)).click((e)=>{
			e.preventDefault()
			removeIndicator('annotation', annotationClicked.clipRect.id)
			$('#contextMenu').remove()
			$('#dark-contextMenu').remove()
			$(".iChart-indicators-modal").remove()
		})
		var option3 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Color">${SVG_ICONS[/*'colorPalette'*/'colour_pallete']} Color</span>`)).click((e)=>{
			e.preventDefault()
			if(!$('.color-square')[0] || !$('.color-square')[0]){
				buildIndicatorsModal('color','annotation', annotationClicked,x,y)
			}else{
				$(".iChart-indicators-modal").remove()
			}
			
		})
		var option4 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Stroke Width">${SVG_ICONS['ruler']} Width</span>`)).click((e)=>{
			e.preventDefault()
			if(!$('#inputIndicatorModal')[0] || !$('#inputIndicatorModal')[0]){
				buildIndicatorsModal('width','annotation', annotationClicked,x,y)
			}else{
				$(".iChart-indicators-modal").remove()
			}
		})
		var option5 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`${isDarkMode? '<span title="Font size">' + `${SVG_ICONS["font size darkmode"]}`+ 'Font size</span>' : '<span title="Font size">' + `${SVG_ICONS["font size"]}` + 'Font size</span>'}`)).click((e)=>{
			e.preventDefault()
			if(!$('#inputIndicatorModal')[0] || !$('#inputIndicatorModal')[0]){
				buildIndicatorsModal('font size','annotation', annotationClicked,x,y)
			}else{
				$(".iChart-indicators-modal").remove()
			}
		})
		var option6 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Text color">${SVG_ICONS[/*'colorPalette'*/'colour_pallete']} Text color</span>`)).click((e)=>{
			e.preventDefault()
			if(!$('.color-square')[0] || !$('.color-square')[0]){
				buildIndicatorsModal('text color','annotation', annotationClicked,x,y)
			}else{
				$(".iChart-indicators-modal").remove()
			}
			
		})
		var option7 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Background color">${SVG_ICONS[/*'colorPalette'*/'colour_pallete']} Background color</span>`)).click((e)=>{
			e.preventDefault()
			if(!$('.color-square')[0] || !$('.color-square')[0]){
				buildIndicatorsModal('background color','annotation', annotationClicked,x,y)
			}else{
				$(".iChart-indicators-modal").remove()
			}
			
		})
		var option8 = div({}, { 'class': isDarkMode == true ? 'dark-contextMenuItem dark-svg': 'contextMenuItem' }).append($(`<span title="Edit">${SVG_ICONS['edit']} Edit</span>`)).click((e)=>{
			e.preventDefault()
			removeTextAnnotationPopup()
			addTextAnnotationPopup(annotationClicked, x + window.scrollX, y + window.scrollY + 15)
			$('#contextMenu').remove()
			$('#dark-contextMenu').remove()
			$(".iChart-indicators-modal").remove()
		})
	
		if (annotationClicked.userOptions.langKey && annotationClicked.userOptions.langKey.toLowerCase() == 'label') {
			contextMenuDiv.append(option6, option5, option7, option8, option2)
		} else {
			contextMenuDiv.append(option3, option4,option1,option2)
		}

	$(".iChart-wrapper").append(contextMenuDiv);
	}
}


$(document).on('click', function(e) {
	var container = (isDarkMode == true ? $("#dark-contextMenu") : $("#contextMenu"));

	if (!$(e.target).closest(container).length) {
		var targetEle = $(e.target);
		var u=[]
		if(targetEle[0].className.length > 0){
			u = targetEle[0].className.split(" ")
		}
				if(u.length > 0 && (u[0] == 'color-square' || u[0] == 'contextInput')){
				}else{
					if(container){
							container.remove();
						}
						if($('.iChart-indicators-modal')){
							$(".iChart-indicators-modal").remove()
						}
				}
		}
});

$(document).keydown(function(event){
	if(event.keyCode == 46){
		if(_th.chart.annotations.length > 0){
			for(let delAnnotation of _th.chart.annotations){
				if (delAnnotation.controlPoints[0]) {
					if (delAnnotation.controlPoints[0].options.visible == true) {
						removeIndicator('annotation', delAnnotation.clipRect.id)
						$('#contextMenu').remove()
						$('#dark-contextMenu').remove()
					}
				} else if (delAnnotation.labels[0]) {
					if (delAnnotation.labels[0].controlPoints[0]) {
						if (delAnnotation.labels[0].controlPoints[0].options.visible == true) {
							removeIndicator('annotation', delAnnotation.clipRect.id)
							$('#contextMenu').remove()
							$('#dark-contextMenu').remove()
						}
					}
				}
			}
		}
	}
	if(event.keyCode == 45){
		if(_th.chart.annotations.length > 0){
			for(let copyAnnotation of _th.chart.annotations){
				if(copyAnnotation.controlPoints[0].options.visible == true){
					cloneAnnotation(copyAnnotation)
					$('#contextMenu').remove()
					$('#dark-contextMenu').remove()
				}
			}
		}
	}
});

function updateTrendingLine(setting, annotationSelected, type, indicatorColor, width = 2){
	if(type=='annotation'){
		let config = {}
		if(setting == 'color'){
			config.typeOptions ={
				"line": {
						"stroke": indicatorColor
				}
		}
		}else if(setting == 'width'){
		// 	config.typeOptions ={
		// 		"line": {				
		// 			"strokeWidth": (isDarkMode==true ? $("#dark-inputIndicatorModal").val() : $("#inputIndicatorModal").val()),
		// 		}
		// }
		config.typeOptions ={
				"line": {				
						"strokeWidth": width
				}
		}
		}

	annotationSelected.update(config)
	//$(".iChart-indicators-modal").remove();
	}else{
		globalPeriod = $("#inputIndicatorModal").val()
		$(".iChart-indicators-modal").hide();
		removeIndicator('indicator', idToBeRemovedGlobal)
		buildIndicator(indicatorColor)
	}
}

function buildIndicatorsModal(setting, type, annotationSelected,x,y){
	$(".iChart-indicators-modal").remove()
	var indicatorColor = annotationSelected.options.typeOptions? annotationSelected.options.typeOptions.line.stroke : undefined

	if(setting == 'width'){
		var iModalWrapper = div({ top: 36+y+'px', left: 136+x+'px'}, { 'class': 'iChart-indicators-modal' });
		var input = $(`<input id=` + (isDarkMode == true ?  "dark-inputIndicatorModal": "inputIndicatorModal") + ` class="contextInput" step="1" type="number" value="`+(type == 'annotation' ? annotationSelected.options.typeOptions.line.strokeWidth : 15)+`"/>`).on("change", (e)=>{
		updateTrendingLine(setting, annotationSelected, type, indicatorColor)
	})
	} else if (setting == 'font size') {
		let fontSize = Number(annotationSelected.labels[0].options.style.fontSize.slice(0, -2))
		var iModalWrapper = div({ top: 36+y+'px', left: 136+x+'px'}, { 'class': 'iChart-indicators-modal' });
		var input = $(`<input id=` + (isDarkMode == true ?  "dark-inputIndicatorModal": "inputIndicatorModal") + ` class="contextInput" step="1" type="number" min="1" value="`+(type == 'annotation' ? fontSize : 15)+`"/>`).on("change", (e)=>{
		updateTextAnnotation(setting, annotationSelected, indicatorColor)
	})
	} else if(setting == 'color'){
		var iModalWrapper = div({ top: 2+y+'px', left: 136+x+'px'}, { 'class': 'iChart-indicators-modal' });
		var divModalColors = div({}, { 'class': 'iChart-indicators-modal-colors' });
	
			var colorArraysInd = (isDarkMode == true ?['#FFFFFF', '#FFFF99', '#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#7F20C1', '#9F1010'] : ['#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#504444', '#7F20C1', '#9F1010', '#130C0C'])
	
		for(let color of colorArraysInd){
			var indicatorC = $('<a id="color-'+color.replace("#",'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
				$('#color-'+indicatorColor.replace("#",'')).removeClass( "color-square-active" )
	
				indicatorColor = color
				updateTrendingLine(setting, annotationSelected, type, indicatorColor)
				$('#color-'+color.replace("#",'')).addClass('color-square-active')
			})
			divModalColors.append(indicatorC)
		}
	} else if(setting == 'text color'){
		indicatorColor = annotationSelected.labels[0].options.style.color
		var iModalWrapper = div({ top: 2+y+'px', left: 136+x+'px'}, { 'class': 'iChart-indicators-modal' });
		var divModalColors = div({}, { 'class': 'iChart-indicators-modal-colors' });
	
			// var colorArraysInd = (isDarkMode == true ?['#FFFFFF', '#FFFF99', '#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#7F20C1', '#9F1010', '#000000'] : ['#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#504444', '#7F20C1', '#9F1010', '#130C0C', '#FFFFFF'])
			var colorArraysInd = ['#f23645', '#ff9800', '#ffeb3b', '#4caf50', '#089981', '#00bcd4', '#2962ff', '#673ab7', '#9c27b0', '#e91e63', '#ffffff', '#000000']
		for(let color of colorArraysInd){
			var indicatorC = $('<a id="color-'+color.replace("#",'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
				$('#color-'+indicatorColor.replace("#",'')).removeClass( "color-square-active" )
	
				indicatorColor = color
				updateTextAnnotation(setting, annotationSelected, indicatorColor)
				$('#color-'+color.replace("#",'')).addClass('color-square-active')
			})
			divModalColors.append(indicatorC)
		}
	} else if(setting == 'background color'){
		indicatorColor = "rgba(0, 0, 0, 0.75)"
		var iModalWrapper = div({ top: 2+y+'px', left: 136+x+'px'}, { 'class': 'iChart-indicators-modal' });
		var divModalColors = div({}, { 'class': 'iChart-indicators-modal-colors' });
	
			// var colorArraysInd = (isDarkMode == true ?['#FFFFFF', '#FFFF99', '#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#7F20C1', '#9F1010', 'rgba(0, 0, 0, 0.75)'] : ['rgba(255, 92, 37, 0.75)', 'rgba(255, 51, 255, 0.75)', 'rgba(47, 152, 15, 0.75)', 'rgba(230, 51, 26, 0.75)', 'rgba(0, 78, 149, 0.75)', 'rgba(80, 68, 68, 0.75)', 'rgba(127, 32, 193, 0.75)', 'rgba(159, 16, 16, 0.75)', 'rgba(19, 12, 12, 0.75)', 'rgba(255, 255, 255, 0.75)'])
			var colorArraysInd = ['rgba(242, 54, 54, 0.75)', 'rgba(255, 152, 152, 0.75)', 'rgba(255, 235, 235, 0.75)', 'rgba(76, 175, 175, 0.75)', 'rgba(8, 153, 153, 0.75)', 'rgba(0, 188, 188, 0.75)', 'rgba(41, 98, 98, 0.75)', 'rgba(103, 58, 58, 0.75)', 'rgba(156, 39, 39, 0.75)', 'rgba(233, 30, 30, 0.75)', 'rgba(255, 255, 255, 0.75)', 'rgba(0, 0, 0, 0.75)']
		for(let color of colorArraysInd){
			var indicatorC = $('<a id="color-'+color.replace(/[ ,.()#]/g,'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
				$('#color-'+indicatorColor.replace(/[ ,.()#]/g,'')).removeClass( "color-square-active" )
	
				indicatorColor = color
				updateTextAnnotation(setting, annotationSelected, indicatorColor)
				$('#color-'+color.replace(/[ ,.()#]/g,'')).addClass('color-square-active')
			})
			divModalColors.append(indicatorC)
		}
	}

	var iModalBtn = div({}, { 'class': 'iChart-indicators-modal-buttons' });
	var cancelBtn = $('<a class="iChart-btn ' + (isDarkMode == true ? "dark-iChart-cancel" : "iChart-cancel") + '"> X </a>')

	cancelBtn.click(function(){
		indicatorChoosen = undefined
		idToBeRemovedGlobal = null;
		$(".iChart-indicators-modal").remove();
	})
	
	//iModalBtn.append(cancelBtn)

	if(IsDarkMode==true){
		$(iModalWrapper).css("background-color","#1b1a1a")
	}

	if(setting == 'color' || setting == 'text color' || setting == 'background color'){
		iModalWrapper.append(divModalColors)
	}else if(setting == 'width' || setting == 'font size'){
		iModalWrapper.append(input)
	}

	$(".iChart-wrapper").append(iModalWrapper);
}

function buildChartMenu_span_bottom() {
	var _this = this,
	    span = {},
	    cnt = div({}, {
		'class': !isMobile? 'iChart-menu2-bottom-cnt-horizontal' : 'iChart-menu2-bottom-cnt-horizontal mobile-footer'
	});

	_this.bottom_wrapper.append(cnt);

	span.hide = function () {
		cnt.hide();
	};
	span.show = function () {
		cnt.show();
	};

	span.update = function (cdata, chart, isYield) {
		if(has_intraday == false) {
			cdata.isIntraday = false
		}

		var chartType = cdata.isIntraday || cdata.unique == 'intraday' ? 'intraday' : 'rest',
			currentSpan = (cdata.span || '1d').toLowerCase();

		var from = SPAN_PICKER[chartType];

		if (isYield) {
			this.hide();
			return;
		}

		if (!from) {
			return;
		}
		cnt.show();
		cnt.empty();
		for (var i = 0; i < from.length; i++) {

			var aux = from[i],

				a = $('<a class="" title="'+aux.fullText+'" data-span="' + aux.val.toLowerCase() + '">' + aux.text + '</a>').on('click', function (e) {
					e.preventDefault();
					resetAnnotations(true)
					_this.events.spanChange($(this).attr('data-span'));
				});

			if (currentSpan == aux.val.toLowerCase()) {
				a.addClass('selected');
			}

			if (cdata.isPlus5 == false){
				if(from[i].val.toLowerCase() != '5y' && from[i].val.toLowerCase() != '10y' && from[i].val.toLowerCase() != '25y' && from[i].val.toLowerCase() != '50y'){
					cnt.append(a);
				}
			}
			else if (cdata.isPlus10 == false){
				if(from[i].val.toLowerCase() != '10y' && from[i].val.toLowerCase() != '25y' && from[i].val.toLowerCase() != '50y'){
					cnt.append(a);
				}
			}
			else if (cdata.isPlus25 == false){
				if(from[i].val.toLowerCase() != '25y' && from[i].val.toLowerCase() != '50y'){
					cnt.append(a);
				}
			}
			else if (cdata.isPlus50 == false){
				if(from[i].val.toLowerCase() != '50y'){
					cnt.append(a);
				}
			}
			else {
				cnt.append(a);
			}
		}

		if (_this.chartProfile) {
			var arr = _this.chartProfile.spans;

			cnt.find('a').each(function (index, element) {
				var ele = $(element),
				    data_span = ele.attr('data-span').toUpperCase();

				if (arr.indexOf(data_span) >= 0) {
					ele.show();
				} else {
					ele.hide();
				}
			});
		} else {
			cnt.find('a').show();
		}
	};
	_this.options['span'] = span;
};

$(document).on('contextmenu', function(e) {
	if (e.button == 2 && (e.target.classList.contains("closeLine") || e.target.classList.contains("highcharts-tracker-line") || e.target.classList.contains("crosshair-fix-vertical") || e.target.classList.contains("crosshair-fix-horizontal") || e.target.classList.contains("highcharts-background"))) {
		e.preventDefault();
		if (countToResetDraw == 0  || countToResetDraw == 2){
			const a = $(".highcharts-segment");
			a.click();
			$("#iChartHeader-annotationPicker-button").addClass("draw-trendline-active")
			$("#control-bar-wrapper").css("display","none")
			_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});
		}
	}
});